(() => {
  const dictionaries = {
  "en": {
    "Lingerie élégante qui sublime votre silhouette": "Elegant lingerie, chosen to flatter with confidence",
    "Des pièces raffinées alliant confort, maintien et sensualité au quotidien": "Curated pieces that blend comfort, support, and quiet sensuality",
    "Je découvre": "Discover the edit",
    "<strong>Chic. Sensuelle. Confortable</strong>": "<strong>Chic. Comfortable. Sensual.</strong>",
    "Une lingerie féminine premium pensée pour vous donner confiance.": "Premium feminine lingerie designed to make confidence feel effortless.",
    "Découvrir la sélection": "Shop the collection",
    "✦ Livraison rapide et suivie en Europe": "✦ Fast tracked delivery across Europe",
    "✦ Création européenne sélectionnée avec exigence": "✦ Carefully selected European designs",
    "✦ Matières douces, confortables et durables": "✦ Soft premium materials made to last",
    "✦ Coupes pensées pour sublimer chaque silhouette": "✦ Flattering fits for every silhouette",
    "✦ Finitions soignées pour une allure impeccable": "✦ Refined finishes for a polished look",
    "NOTRE UNIVERS": "OUR EDIT",
    "Une lingerie choisie pour révéler votre féminité avec élégance": "Lingerie curated to make confidence feel natural",
    "Moins de 20 €": "Under €20",
    "Séduction": "Seduction",
    "Essentiels": "Essentials",
    "Nuit": "Nightwear",
    "Confort": "Comfort",
    "Silhouette": "Silhouette",
    "Bodys": "Bodysuits",
    "Intimité": "Intimates",
    "Collants": "Tights",
    "L'ÉDITION DU MOMENT": "THE EDIT OF THE MOMENT",
    "Sélection exclusive": "Exclusive selection",
    "Combinaisons": "Jumpsuits",
    "LES PIÈCES SIGNATURE": "SIGNATURE PIECES",
    "Les incontournables": "The pieces customers come back for",
    "À découvrir": "Discover",
    "Incontournables": "Must-haves",
    "Élégance": "Elegance",
    "Nouveautés": "New arrivals",
    "Offre": "Sale",
    "Tout voir": "View all",
    "Édition limitée. Désir immédiat.": "Limited edition. Made to be desired.",
    "Découvrez des pièces rares, sélectionnées pour sublimer votre silhouette avec élégance. Disponibilité limitée.": "Discover rare pieces selected to flatter beautifully. Limited availability.",
    "J'en profite": "Shop now",
    "Nos maisons partenaires": "Our partner brands",
    "Sélection de maisons européennes d'exception": "A curated selection of exceptional European labels",
    "Pourquoi choisir Secretelles": "Why choose Secretelles",
    "L'élégance, avec la confiance en plus": "Elegance, with confidence built in",
    "Livraison internationale suivie": "Tracked international delivery",
    "<p>Un suivi clair, jusqu'à votre porte</p>": "<p>Clear tracking from dispatch to your door</p>",
    "Livraison offerte": "Free delivery",
    "<p>Sans mauvaise surprise au panier</p>": "<p>No surprise fees at the cart</p>",
    "Paiement 100 % sécurisé": "100% secure payment",
    "<p>Transactions protégées par SSL</p>": "<p>SSL-protected transactions</p>",
    "Retours simples sous 30 jours": "Simple 30-day returns",
    "<p>Achetez l'esprit tranquille</p>": "<p>Try your pieces with peace of mind</p>"
  },
  "de": {
    "Lingerie élégante qui sublime votre silhouette": "Elegante Dessous, die Ihre Silhouette stilvoll betonen",
    "Des pièces raffinées alliant confort, maintien et sensualité au quotidien": "Ausgewählte Modelle mit Komfort, Halt und dezenter Sinnlichkeit",
    "Je découvre": "Auswahl entdecken",
    "<strong>Chic. Sensuelle. Confortable</strong>": "<strong>Stilvoll. Bequem. Sinnlich.</strong>",
    "Une lingerie féminine premium pensée pour vous donner confiance.": "Premium-Dessous für ein sicheres Gefühl, jeden Tag.",
    "Découvrir la sélection": "Kollektion entdecken",
    "✦ Livraison rapide et suivie en Europe": "✦ Schnelle Lieferung mit Sendungsverfolgung in Europa",
    "✦ Création européenne sélectionnée avec exigence": "✦ Sorgfältig ausgewählte Designs aus Europa",
    "✦ Matières douces, confortables et durables": "✦ Weiche Premium-Materialien mit langlebiger Qualität",
    "✦ Coupes pensées pour sublimer chaque silhouette": "✦ Passformen, die jede Silhouette vorteilhaft betonen",
    "✦ Finitions soignées pour une allure impeccable": "✦ Sorgfältige Verarbeitung für einen gepflegten Look",
    "NOTRE UNIVERS": "UNSERE AUSWAHL",
    "Une lingerie choisie pour révéler votre féminité avec élégance": "Dessous, die Stil, Komfort und Selbstvertrauen verbinden",
    "Moins de 20 €": "Unter 20 €",
    "Séduction": "Verführung",
    "Essentiels": "Essentials",
    "Nuit": "Nachtwäsche",
    "Confort": "Komfort",
    "Silhouette": "Silhouette",
    "Bodys": "Bodys",
    "Intimité": "Intimates",
    "Collants": "Strumpfhosen",
    "L'ÉDITION DU MOMENT": "DIE AUSWAHL DER SAISON",
    "Sélection exclusive": "Exklusive Auswahl",
    "Combinaisons": "Jumpsuits",
    "LES PIÈCES SIGNATURE": "SIGNATURE-STÜCKE",
    "Les incontournables": "Favoriten, die überzeugen",
    "À découvrir": "Entdecken",
    "Incontournables": "Favoriten",
    "Élégance": "Eleganz",
    "Nouveautés": "Neuheiten",
    "Offre": "Sale",
    "Tout voir": "Alles ansehen",
    "Édition limitée. Désir immédiat.": "Limitierte Edition. Stilvoll begehrt.",
    "Découvrez des pièces rares, sélectionnées pour sublimer votre silhouette avec élégance. Disponibilité limitée.": "Entdecken Sie seltene Stücke, ausgewählt für eine elegante Silhouette. Nur begrenzt verfügbar.",
    "J'en profite": "Jetzt shoppen",
    "Nos maisons partenaires": "Unsere Partnermarken",
    "Sélection de maisons européennes d'exception": "Eine kuratierte Auswahl besonderer europäischer Marken",
    "Pourquoi choisir Secretelles": "Warum Secretelles",
    "L'élégance, avec la confiance en plus": "Eleganz mit Vertrauen in jedes Detail",
    "Livraison internationale suivie": "Internationale Lieferung mit Sendungsverfolgung",
    "<p>Un suivi clair, jusqu'à votre porte</p>": "<p>Transparent nachverfolgbar bis zu Ihrer Tür</p>",
    "Livraison offerte": "Kostenloser Versand",
    "<p>Sans mauvaise surprise au panier</p>": "<p>Ohne unerwartete Kosten im Warenkorb</p>",
    "Paiement 100 % sécurisé": "100 % sichere Zahlung",
    "<p>Transactions protégées par SSL</p>": "<p>SSL-geschützte Transaktionen</p>",
    "Retours simples sous 30 jours": "Einfache Rückgabe innerhalb von 30 Tagen",
    "<p>Achetez l'esprit tranquille</p>": "<p>In Ruhe anprobieren und sicher entscheiden</p>"
  },
  "es": {
    "Lingerie élégante qui sublime votre silhouette": "Lecería elegante para realzar tu silueta con confianza",
    "Des pièces raffinées alliant confort, maintien et sensualité au quotidien": "Prendas seleccionadas que unen comodidad, soporte y sensualidad sutil",
    "Je découvre": "Ver la selección",
    "<strong>Chic. Sensuelle. Confortable</strong>": "<strong>Chic. Cómoda. Sensual.</strong>",
    "Une lingerie féminine premium pensée pour vous donner confiance.": "Lecería femenina premium para sentirte segura sin esfuerzo.",
    "Découvrir la sélection": "Descubrir la colección",
    "✦ Livraison rapide et suivie en Europe": "✦ Entrega rápida con seguimiento en Europa",
    "✦ Création européenne sélectionnée avec exigence": "✦ Diseños europeos seleccionados con mimo",
    "✦ Matières douces, confortables et durables": "✦ Materiales suaves, premium y duraderos",
    "✦ Coupes pensées pour sublimer chaque silhouette": "✦ Cortes que favorecen cada silueta",
    "✦ Finitions soignées pour une allure impeccable": "✦ Acabados cuidados para un look impecable",
    "NOTRE UNIVERS": "NUESTRO UNIVERSO",
    "Une lingerie choisie pour révéler votre féminité avec élégance": "Lecería elegida para sentirte segura, cómoda y femenina",
    "Moins de 20 €": "Menos de 20 €",
    "Séduction": "Seducción",
    "Essentiels": "Esenciales",
    "Nuit": "Noche",
    "Confort": "Comodidad",
    "Silhouette": "Silueta",
    "Bodys": "Bodys",
    "Intimité": "Íntimos",
    "Collants": "Pantys",
    "L'ÉDITION DU MOMENT": "LA EDICIÓN DEL MOMENTO",
    "Sélection exclusive": "Selección exclusiva",
    "Combinaisons": "Monos",
    "LES PIÈCES SIGNATURE": "PIEZAS SIGNATURE",
    "Les incontournables": "Los imprescindibles que siempre funcionan",
    "À découvrir": "Descubrir",
    "Incontournables": "Imprescindibles",
    "Élégance": "Elegancia",
    "Nouveautés": "Novedades",
    "Offre": "Oferta",
    "Tout voir": "Ver todo",
    "Édition limitée. Désir immédiat.": "Edición limitada. Deseo inmediato.",
    "Découvrez des pièces rares, sélectionnées pour sublimer votre silhouette avec élégance. Disponibilité limitée.": "Descubre piezas especiales elegidas para realzar tu silueta con elegancia. Disponibilidad limitada.",
    "J'en profite": "Comprar ahora",
    "Nos maisons partenaires": "Nuestras marcas asociadas",
    "Sélection de maisons européennes d'exception": "Selección curada de marcas europeas excepcionales",
    "Pourquoi choisir Secretelles": "Por qué elegir Secretelles",
    "L'élégance, avec la confiance en plus": "Elegancia con confianza en cada detalle",
    "Livraison internationale suivie": "Entrega internacional con seguimiento",
    "<p>Un suivi clair, jusqu'à votre porte</p>": "<p>Seguimiento claro hasta tu puerta</p>",
    "Livraison offerte": "Envío gratis",
    "<p>Sans mauvaise surprise au panier</p>": "<p>Sin sorpresas al finalizar tu compra</p>",
    "Paiement 100 % sécurisé": "Pago 100 % seguro",
    "<p>Transactions protégées par SSL</p>": "<p>Transacciones protegidas con SSL</p>",
    "Retours simples sous 30 jours": "Devoluciones sencillas en 30 días",
    "<p>Achetez l'esprit tranquille</p>": "<p>Compra y pruébate con tranquilidad</p>"
  },
  "nl": {
    "Lingerie élégante qui sublime votre silhouette": "Verfijnde lingerie die uw silhouet flateert",
    "Des pièces raffinées alliant confort, maintien et sensualité au quotidien": "Geselecteerde stukken met comfort, ondersteuning en subtiele sensualiteit",
    "Je découvre": "Ontdek de collectie",
    "<strong>Chic. Sensuelle. Confortable</strong>": "<strong>Stijlvol. Comfortabel. Sensueel.</strong>",
    "Une lingerie féminine premium pensée pour vous donner confiance.": "Premium dameslingerie voor een zelfverzekerd gevoel, elke dag.",
    "Découvrir la sélection": "Bekijk de collectie",
    "✦ Livraison rapide et suivie en Europe": "✦ Snelle verzending met tracking in Europa",
    "✦ Création européenne sélectionnée avec exigence": "✦ Zorgvuldig geselecteerde Europese ontwerpen",
    "✦ Matières douces, confortables et durables": "✦ Zachte premium materialen van blijvende kwaliteit",
    "✦ Coupes pensées pour sublimer chaque silhouette": "✦ Pasvorm die elk figuur flateert",
    "✦ Finitions soignées pour une allure impeccable": "✦ Verfijnde afwerking voor een onberispelijk resultaat",
    "NOTRE UNIVERS": "ONZE COLLECTIE",
    "Une lingerie choisie pour révéler votre féminité avec élégance": "Lingerie gekozen voor stijl, comfort en zelfvertrouwen",
    "Moins de 20 €": "Onder €20",
    "Séduction": "Verleiding",
    "Essentiels": "Basislingerie",
    "Nuit": "Nachtkleding",
    "Confort": "Comfort",
    "Silhouette": "Silhouet",
    "Bodys": "Bodysuits",
    "Intimité": "Intimates",
    "Collants": "Panty's",
    "L'ÉDITION DU MOMENT": "DE EDITIE VAN NU",
    "Sélection exclusive": "Exclusieve selectie",
    "Combinaisons": "Jumpsuits",
    "LES PIÈCES SIGNATURE": "SIGNATURE STUKKEN",
    "Les incontournables": "De stukken waar klanten voor terugkomen",
    "À découvrir": "Ontdekken",
    "Incontournables": "Must-haves",
    "Élégance": "Elegantie",
    "Nouveautés": "Nieuw binnen",
    "Offre": "Sale",
    "Tout voir": "Alles bekijken",
    "Édition limitée. Désir immédiat.": "Gelimiteerde editie. Direct begeerd.",
    "Découvrez des pièces rares, sélectionnées pour sublimer votre silhouette avec élégance. Disponibilité limitée.": "Ontdek bijzondere stukken geselecteerd om uw silhouet elegant te flateereren. Beperkte beschikbaarheid.",
    "J'en profite": "Nu winkelen",
    "Nos maisons partenaires": "Onze partnermerken",
    "Sélection de maisons européennes d'exception": "Een curated selectie van uitzonderlijke Europese merken",
    "Pourquoi choisir Secretelles": "Waarom Secretelles",
    "L'élégance, avec la confiance en plus": "Elegantie met vertrouwen in elk detail",
    "Livraison internationale suivie": "Internationale verzending met tracking",
    "<p>Un suivi clair, jusqu'à votre porte</p>": "<p>Duidelijke tracking tot aan uw deur</p>",
    "Livraison offerte": "Gratis verzending",
    "<p>Sans mauvaise surprise au panier</p>": "<p>Geen verrassingen bij het afrekenen</p>",
    "Paiement 100 % sécurisé": "100% veilig betalen",
    "<p>Transactions protégées par SSL</p>": "<p>SSL-beveiligde transacties</p>",
    "Retours simples sous 30 jours": "Eenvoudig retourneren binnen 30 dagen",
    "<p>Achetez l'esprit tranquille</p>": "<p>Probeer uw stukken zonder zorgen</p>"
  }
};
  const host = window.location.hostname;
  const lang = host.startsWith('en.') ? 'en' : host.startsWith('de.') ? 'de' : host.startsWith('es.') ? 'es' : host.startsWith('nl.') ? 'nl' : null;
  if (!lang || !dictionaries[lang]) return;
  if (window.location.pathname.replace(/\/$/, '') !== '') return;

  const normalize = (value) => value.replace(/\s+/g, ' ').trim();
  const dictionary = Object.fromEntries(
    Object.entries(dictionaries[lang]).map(([key, value]) => [normalize(key), value])
  );

  const replaceText = () => {
    if (!document.body) return;
    const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        if (!node.nodeValue || !node.nodeValue.trim()) return NodeFilter.FILTER_REJECT;
        const parent = node.parentElement;
        if (!parent || ['SCRIPT', 'STYLE', 'NOSCRIPT'].includes(parent.tagName)) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach((node) => {
      const original = node.nodeValue;
      const replacement = dictionary[normalize(original)];
      if (replacement) node.nodeValue = original.replace(original.trim(), replacement);
    });
  };

  const run = () => {
    replaceText();
    window.setTimeout(replaceText, 250);
    window.setTimeout(replaceText, 1000);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }
})();

/* secretelles_final_market_i18n_20260521 */
(function () {
  var host = (window.location.hostname || "").toLowerCase();
  var htmlLang = (document.documentElement.lang || "").toLowerCase();
  var market = host.indexOf("de.") === 0 || htmlLang.indexOf("de") === 0 ? "de" :
    host.indexOf("es.") === 0 || htmlLang.indexOf("es") === 0 ? "es" :
    host.indexOf("nl.") === 0 || htmlLang.indexOf("nl") === 0 ? "nl" :
    host.indexOf("en.") === 0 || htmlLang.indexOf("en") === 0 ? "en" : "fr";

  var data = {
    fr: {
      newBadge: "NEW", saleBadge: "-80%", giftBadge: "GIFT", saleProduct: "Offre spéciale",
      cart: ["Votre panier", "Panier sécurisé", "Livraison offerte", "Paiement SSL", "Suivi colis", "Livraison offerte dans nos pays sélectionnés.", "Prêt pour le checkout", "Paiement protégé et commande suivie après expédition.", "Remise appliquée", "Sous-total", "Finaliser ma commande", "Ajouter une note à votre commande"]
    },
    en: {
      newBadge: "NEW", saleBadge: "-80%", giftBadge: "GIFT", saleProduct: "Special offer",
      cart: ["Your bag", "Secure basket", "Free delivery", "SSL payment", "Tracking", "Free delivery to selected countries.", "Ready for checkout", "Protected payment and tracked order after dispatch.", "Discount applied", "Subtotal", "Checkout", "Add a note to your order"],
      replace: {
        "Lingerie Premium": "Premium Lingerie",
        "Maison européenne de lingerie féminine": "European lingerie maison",
        "Soutiens-gorge, ensembles et nuit élégante : confort, maintien et raffinement européen.": "Bras, sets and refined nightwear with comfort, support and European elegance.",
        "Découvrir la sélection": "Shop the collection",
        "Voir les nouveautés": "View new arrivals",
        "Livraison offerte": "Free delivery",
        "Paiement sécurisé SSL": "Secure SSL payment",
        "Paiement SSL": "SSL payment",
        "Suivi colis": "Tracked delivery",
        "Choix de taille aidé": "Size guidance",
        "Sélections Signature": "Signature Selection",
        "Explorer les essentiels Secretelles": "Explore refined Secretelles essentials",
        "Sélection Haute Désirabilité": "Most Desired Pieces",
        "Pièces premium prêtes à sublimer la silhouette": "Premium pieces chosen for fit, comfort and confidence",
        "Sous-vêtements par envie": "Lingerie By Mood",
        "Choisir la base parfaite pour votre silhouette": "Find the base that feels right under every outfit",
        "Robes par occasion": "Dresses By Occasion",
        "La tenue qui change votre entrée": "Dresses that make every entrance feel effortless",
        "Marques européennes": "European Brands",
        "Fabriqué en Europe, choisi pour sa coupe": "Made in Europe, selected for fit and lasting elegance",
        "Acheter en toute confiance": "Shop With Confidence",
        "Chaque détail rassure avant l’achat": "Clear sizing, secure payment and tracked delivery",
        "Avis clientes": "Verified Reviews",
        "Des retours qui comptent vraiment, partagés après réception et essayage.": "Reviews that truly matter, shared after delivery and fitting.",
        "Club Secretelles": "Secretelles Club",
        "Votre sélection privée": "Your Private Selection",
        "Recevez une sélection intime de lingerie femme, robes, nuit élégante et conseils taille, avec des inspirations pensées pour choisir plus juste et se sentir sûre avant d’acheter.": "Receive refined lingerie, dresses, nightwear and size advice chosen to help you buy with confidence.",
        "Secretelles réunit lingerie femme, soutiens-gorge, culottes, strings, pyjamas, nuisettes, robes et peignoirs européens, avec livraison offerte dans les pays sélectionnés.": "Secretelles brings together women’s lingerie, bras, briefs, thongs, pyjamas, nightdresses, dresses and European robes, with free delivery to selected countries.",
        "Voir tailles": "View sizes", "VOIR TAILLES": "VIEW SIZES",
        "Offre spéciale": "Special offer"
      }
    },
    es: {
      newBadge: "NUEVO", saleBadge: "-80%", giftBadge: "REGALO", saleProduct: "Oferta especial",
      cart: ["Tu bolsa", "Carrito seguro", "Envío gratis", "Pago SSL", "Seguimiento", "Envío gratis en los países seleccionados.", "Listo para pagar", "Pago protegido y pedido con seguimiento tras el envío.", "Descuento aplicado", "Subtotal", "Completar pedido", "Añade una nota a tu pedido"],
      replace: {
        "Lingerie Premium": "Lencería Premium",
        "Maison européenne de lingerie féminine": "Maison europea de lencería femenina",
        "Soutiens-gorge, ensembles et nuit élégante : confort, maintien et raffinement européen.": "Sujetadores, conjuntos y noche elegante con confort, sujeción y refinamiento europeo.",
        "Découvrir la sélection": "Descubrir la selección",
        "Voir les nouveautés": "Ver novedades",
        "Livraison offerte": "Envío gratis",
        "Paiement sécurisé SSL": "Pago seguro SSL",
        "Paiement SSL": "Pago SSL",
        "Suivi colis": "Seguimiento",
        "Choix de taille aidé": "Guía de talla",
        "Sélections Signature": "Selección Signature",
        "Explorer les essentiels Secretelles": "Descubre los esenciales Secretelles",
        "Sélection Haute Désirabilité": "Selección Más Deseada",
        "Pièces premium prêtes à sublimer la silhouette": "Piezas premium elegidas por su ajuste, imagen y confianza",
        "Sous-vêtements par envie": "Lencería Según Tu Momento",
        "Choisir la base parfaite pour votre silhouette": "Elige la base que acompaña tu silueta con naturalidad",
        "Robes par occasion": "Vestidos Por Ocasión",
        "La tenue qui change votre entrée": "Vestidos pensados para entrar con seguridad",
        "Marques européennes": "Marcas Europeas",
        "Fabriqué en Europe, choisi pour sa coupe": "Fabricado en Europa, elegido por corte y elegancia duradera",
        "Acheter en toute confiance": "Comprar Con Confianza",
        "Chaque détail rassure avant l’achat": "Talla clara, pago seguro y pedido con seguimiento",
        "Avis clientes": "Opiniones Verificadas",
        "Des retours qui comptent vraiment, partagés après réception et essayage.": "Opiniones que importan de verdad, compartidas tras recibir y probar la prenda.",
        "Club Secretelles": "Club Secretelles",
        "Votre sélection privée": "Tu selección privada",
        "Recevez une sélection intime de lingerie femme, robes, nuit élégante et conseils taille, avec des inspirations pensées pour choisir plus juste et se sentir sûre avant d’acheter.": "Recibe lencería, vestidos, noche elegante y consejos de talla para elegir con seguridad y estilo.",
        "Secretelles réunit lingerie femme, soutiens-gorge, culottes, strings, pyjamas, nuisettes, robes et peignoirs européens, avec livraison offerte dans les pays sélectionnés.": "Secretelles reúne lencería femenina, sujetadores, braguitas, tangas, pijamas, camisones, vestidos y batas europeas con envío gratis en países seleccionados.",
        "Voir tailles": "Ver tallas", "VOIR TAILLES": "VER TALLAS",
        "Offre spéciale": "Oferta especial"
      }
    },
    de: {
      newBadge: "NEU", saleBadge: "-80%", giftBadge: "GESCHENK", saleProduct: "Spezialangebot",
      cart: ["Ihre Tasche", "Sicherer Warenkorb", "Kostenloser Versand", "SSL-Zahlung", "Sendungsverfolgung", "Kostenloser Versand in ausgewählte Länder.", "Bereit zum Checkout", "Geschützte Zahlung und Sendungsverfolgung nach Versand.", "Angewendeter Rabatt", "Zwischensumme", "Zur Kasse", "Bestellnotiz hinzufügen"],
      replace: {
        "Lingerie Premium": "Premium-Dessous",
        "Maison européenne de lingerie féminine": "Europäische Dessous-Maison",
        "Soutiens-gorge, ensembles et nuit élégante : confort, maintien et raffinement européen.": "BHs, Sets und elegante Nachtwäsche mit Komfort, Halt und europäischer Raffinesse.",
        "Découvrir la sélection": "Kollektion entdecken",
        "Voir les nouveautés": "Neuheiten ansehen",
        "Livraison offerte": "Kostenloser Versand",
        "Paiement sécurisé SSL": "Sichere SSL-Zahlung",
        "Paiement SSL": "SSL-Zahlung",
        "Suivi colis": "Sendungsverfolgung",
        "Choix de taille aidé": "Größenberatung",
        "Sélections Signature": "Signature-Auswahl",
        "Explorer les essentiels Secretelles": "Premium-Dessous für Damen",
        "Sélection Haute Désirabilité": "Beliebte Auswahl",
        "Des produits en stock fort, choisis pour leur image, leur coupe et leur pouvoir de conversion.": "Stark verfügbare Stücke, ausgewählt für Bildwirkung, Passform und Kaufimpuls.",
        "Pièces premium prêtes à sublimer la silhouette": "Ausgewählte Stücke für Passform, Weichheit und Eleganz",
        "Sous-vêtements par envie": "Dessous nach Gefühl",
        "Bras, strings et culottes sélectionnés pour le confort, la confiance et une allure raffinée sous chaque tenue.": "BHs, Strings und Slips, ausgewählt für Komfort, Sicherheit und eine gepflegte Linie unter jedem Outfit.",
        "Choisir la base parfaite pour votre silhouette": "Die passende Basis für jeden Tag",
        "Robes par occasion": "Kleider nach Anlass",
        "Robes de soirée, robes cocktail, robes du jour et combinaisons sélectionnées pour un dîner, une cérémonie, une sortie habillée ou un moment où l'on veut se sentir remarquable.": "Abendkleider, Cocktailkleider, Tageskleider und Jumpsuits für Dinner, Feiern und besondere Auftritte.",
        "La tenue qui change votre entrée": "Bereit für jeden Anlass",
        "Marques européennes": "Europäische Marken",
        "Des marques de lingerie, nuit, robes et dessous fabriquées en Europe, choisies pour leur coupe, leur confort et leur élégance durable.": "Europäische Marken für Dessous, Nachtwäsche, Kleider und Wäsche, ausgewählt für Passform, Komfort und langlebige Eleganz.",
        "Fabriqué en Europe, choisi pour sa coupe": "In Europa gefertigt, für Passform und Qualität gewählt",
        "Acheter en toute confiance": "Sicher einkaufen",
        "Chaque détail rassure avant l’achat": "Klare Größenhilfe, sichere Zahlung und sichtbares Tracking",
        "Une expérience pensée pour réduire le doute : taille plus claire, paiement sécurisé, suivi visible et produits européens sélectionnés avec soin.": "Ein Einkaufserlebnis, das Zweifel reduziert: klare Größenhilfe, sichere Zahlung, sichtbares Tracking und sorgfältig ausgewählte europäische Produkte.",
        "Avis clientes": "Kundenstimmen",
        "Des retours qui comptent vraiment, partagés après réception et essayage.": "Rückmeldungen, die wirklich zählen, geteilt nach Lieferung und Anprobe.",
        "Club Secretelles": "Secretelles Club",
        "Votre sélection privée": "Ihre private Auswahl",
        "Recevez une sélection intime de lingerie femme, robes, nuit élégante et conseils taille, avec des inspirations pensées pour choisir plus juste et se sentir sûre avant d’acheter.": "Erhalten Sie Dessous, Kleider, Nachtwäsche und Größenberatung, damit Sie sicherer und gezielter wählen.",
        "Secretelles réunit lingerie femme, soutiens-gorge, culottes, strings, pyjamas, nuisettes, robes et peignoirs européens, avec livraison offerte dans les pays sélectionnés.": "Secretelles vereint Damen-Dessous, BHs, Slips, Strings, Pyjamas, Nachthemden, Kleider und europäische Morgenmäntel mit kostenlosem Versand in ausgewählte Länder.",
        "TOP DEMANDE": "BELIEBT", "LINGERIE": "DESSOUS", "ESSENCIALS": "BASICS", "CULOTTES & BAS": "SLIPS & STRÜMPFE", "LINGERIE DE NUIT": "NACHTWÄSCHE", "MAINTEIN": "HALT", "MAINTIEN": "HALT", "SOUTIENS-GORGE": "BHS", "SILOUHEUTTE": "SILHOUETTE", "SILHOUETTE": "SILHOUETTE", "SCULPTANTE": "FORMEND",
        "Voir tailles": "Größen ansehen", "VOIR TAILLES": "GRÖSSEN ANSEHEN",
        "Offre spéciale": "Spezialangebot"
      }
    },
    nl: {
      newBadge: "NIEUW", saleBadge: "-80%", giftBadge: "CADEAU", saleProduct: "Speciale aanbieding",
      cart: ["Je winkelmand", "Veilige winkelmand", "Gratis verzending", "SSL-betaling", "Tracking", "Gratis verzending naar geselecteerde landen.", "Klaar om af te rekenen", "Beveiligde betaling en tracking na verzending.", "Toegepaste korting", "Subtotaal", "Afrekenen", "Voeg een opmerking toe"],
      replace: {
        "Lingerie Premium": "Premium Lingerie",
        "Maison européenne de lingerie féminine": "Europese lingeriemaison",
        "Soutiens-gorge, ensembles et nuit élégante : confort, maintien et raffinement européen.": "Bh’s, sets en elegante nachtmode met comfort, steun en Europese verfijning.",
        "Découvrir la sélection": "Bekijk de collectie",
        "Voir les nouveautés": "Bekijk nieuw binnen",
        "Livraison offerte": "Gratis verzending",
        "Paiement sécurisé SSL": "Veilige SSL-betaling",
        "Paiement SSL": "SSL-betaling",
        "Suivi colis": "Tracking",
        "Choix de taille aidé": "Maatadvies",
        "Sélections Signature": "Signature Selectie",
        "Explorer les essentiels Secretelles": "Ontdek de essentials van Secretelles",
        "Sélection Haute Désirabilité": "Meest Gewilde Selectie",
        "Pièces premium prêtes à sublimer la silhouette": "Premium items gekozen voor pasvorm, comfort en uitstraling",
        "Sous-vêtements par envie": "Lingerie Op Gevoel",
        "Choisir la base parfaite pour votre silhouette": "Kies de basis die natuurlijk onder elke outfit past",
        "Robes par occasion": "Jurken Per Gelegenheid",
        "La tenue qui change votre entrée": "Jurken die elke binnenkomst verfijnd maken",
        "Marques européennes": "Europese Merken",
        "Fabriqué en Europe, choisi pour sa coupe": "Gemaakt in Europa, gekozen voor pasvorm en blijvende elegantie",
        "Acheter en toute confiance": "Met Vertrouwen Kopen",
        "Chaque détail rassure avant l’achat": "Duidelijke maten, veilige betaling en zichtbare tracking",
        "Avis clientes": "Geverifieerde Reviews",
        "Des retours qui comptent vraiment, partagés après réception et essayage.": "Reviews die echt tellen, gedeeld na ontvangst en passen.",
        "Club Secretelles": "Secretelles Club",
        "Votre sélection privée": "Jouw privéselectie",
        "Recevez une sélection intime de lingerie femme, robes, nuit élégante et conseils taille, avec des inspirations pensées pour choisir plus juste et se sentir sûre avant d’acheter.": "Ontvang lingerie, jurken, nachtmode en maatadvies om met meer vertrouwen te kiezen.",
        "Secretelles réunit lingerie femme, soutiens-gorge, culottes, strings, pyjamas, nuisettes, robes et peignoirs européens, avec livraison offerte dans les pays sélectionnés.": "Secretelles brengt dameslingerie, bh’s, slips, strings, pyjama’s, nachthemden, jurken en Europese kimono’s samen, met gratis verzending naar geselecteerde landen.",
        "Voir tailles": "Maten bekijken", "VOIR TAILLES": "MATEN BEKIJKEN",
        "Offre spéciale": "Speciale aanbieding"
      }
    }
  };

  function plain(s) { return (s || "").replace(/\s+/g, " ").trim(); }

  function shouldSkip(node) {
    var p = node && node.parentElement;
    if (!p) return true;
    return /^(SCRIPT|STYLE|NOSCRIPT|TEXTAREA|SVG)$/.test(p.tagName);
  }

  function applyText(root) {
    var d = data[market];
    var map = d.replace || {};
    var base = {
      "Offre spéciale": d.saleProduct,
      "Special offer": d.saleProduct,
      "Oferta especial": d.saleProduct,
      "Angebot": d.saleProduct,
      "Spezialangebot": d.saleProduct,
      "Speciale aanbieding": d.saleProduct
    };
    Object.keys(base).forEach(function (k) { map[k] = base[k]; });

    var walker = document.createTreeWalker(root || document.body, NodeFilter.SHOW_TEXT);
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(function (n) {
      if (shouldSkip(n)) return;
      var text = plain(n.nodeValue);
      if (!text) return;
      if (map[text]) {
        n.nodeValue = n.nodeValue.replace(n.nodeValue.trim(), map[text]);
        return;
      }
      Object.keys(map).forEach(function (k) {
        if (n.nodeValue.indexOf(k) !== -1) n.nodeValue = n.nodeValue.replaceAll(k, map[k]);
      });
    });
  }

  function normalizeMenuText(text) {
    var t = plain(text).replace(/\b(NEW|NUEVO|NEU|NIEUW|GIFT|REGALO|GESCHENK|CADEAU|-80%)\b/g, "").trim();
    return t;
  }

  function addBadge(el, type, label) {
    if (!el) return;
    el.querySelectorAll(".se-final-nav-badge,.se-market-nav-badge,.se-local-nav-badge").forEach(function (b) { b.remove(); });
    var badge = document.createElement("span");
    badge.className = "se-final-nav-badge se-final-nav-badge--" + type;
    badge.textContent = label;
    el.appendChild(badge);
  }

  function applyNavBadges() {
    var d = data[market];
    document.querySelectorAll(".se-market-nav-badge,.se-local-nav-badge,.se-final-nav-badge").forEach(function (b) { b.remove(); });
    document.querySelectorAll("header a, header summary, .header__inline-menu a, .header__inline-menu summary").forEach(function (el) {
      var text = normalizeMenuText(el.textContent || "");
      if (/^(Nouveautés|Novidades|Novedades|Neuheiten|Nieuw binnen|New in|New arrivals)$/i.test(text)) addBadge(el, "new", d.newBadge);
      if (/^(Soldes|Sale|Rebajas|Uitverkoop)$/i.test(text)) addBadge(el, "sale", d.saleBadge);
      if (/^(Idées cadeaux|Ideas regalo|Gift ideas|Geschenkideen|Cadeau-ideeën)$/i.test(text)) addBadge(el, "gift", d.giftBadge);
    });
  }

  function applyCartText() {
    var c = data[market].cart;
    var cartMap = {
      "Votre panier": c[0], "Tu bolsa": c[0], "Ihre Tasche": c[0], "Je winkelmand": c[0], "Your bag": c[0],
      "Panier sécurisé": c[1], "Carrito seguro": c[1], "Sicherer Warenkorb": c[1], "Veilige winkelmand": c[1], "Secure basket": c[1],
      "Livraison offerte": c[2], "Envío gratis": c[2], "Kostenloser Versand": c[2], "Gratis verzending": c[2], "Free delivery": c[2],
      "Paiement SSL": c[3], "Pago SSL": c[3], "SSL-Zahlung": c[3], "SSL-betaling": c[3], "SSL payment": c[3],
      "Suivi colis": c[4], "Seguimiento": c[4], "Sendungsverfolgung": c[4], "Tracking": c[4], "Tracked delivery": c[4],
      "Livraison offerte dans nos pays sélectionnés.": c[5],
      "Livraison offerte dans nos pays sélectionnées.": c[5],
      "Prête pour le checkout": c[6], "Prêt pour le checkout": c[6], "Listo para pagar": c[6], "Bereit zum Checkout": c[6], "Klaar om af te rekenen": c[6], "Ready for checkout": c[6],
      "Paiement protégé et commande suivie après expédition.": c[7],
      "Descuento aplicado": c[8], "Remise appliquée": c[8], "Angewendeter Rabatt": c[8], "Toegepaste korting": c[8], "Discount applied": c[8],
      "Subtotal": c[9], "Sous-total": c[9], "Zwischensumme": c[9], "Subtotaal": c[9],
      "Completar Mi Pedido": c[10], "Finaliser ma commande": c[10], "Zur Kasse": c[10], "Afrekenen": c[10], "Checkout": c[10],
      "Añade una nota a tu pedido": c[11], "Ajouter une note à votre commande": c[11], "Bestellnotiz hinzufügen": c[11], "Voeg een opmerking toe": c[11], "Add a note to your order": c[11]
    };
    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(function (n) {
      if (shouldSkip(n)) return;
      Object.keys(cartMap).forEach(function (k) {
        if (n.nodeValue.indexOf(k) !== -1) n.nodeValue = n.nodeValue.replaceAll(k, cartMap[k]);
      });
    });
  }

  function fixProductCards() {
    document.querySelectorAll(".product-card-wrapper .se-product-new-badge span").forEach(function (s) {
      s.textContent = data[market].newBadge;
    });
    document.querySelectorAll(".product-card-wrapper .card__badge .badge").forEach(function (b) {
      var txt = plain(b.textContent);
      if (/Offre spéciale|Special offer|Oferta especial|Angebot|Spezialangebot|Speciale aanbieding/i.test(txt)) b.textContent = data[market].saleProduct;
    });
  }

  function run() {
    applyText(document.body);
    applyCartText();
    applyNavBadges();
    fixProductCards();
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", run);
  else run();

  var timer;
  new MutationObserver(function () {
    clearTimeout(timer);
    timer = setTimeout(run, 120);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();

/* secretelles final market localization and single header badges 2026-05-20 */
(function () {
  var host = window.location.hostname || "";
  var htmlLang = (document.documentElement.lang || "").slice(0, 2).toLowerCase();
  var lang = host.indexOf("es.") === 0 ? "es" : host.indexOf("de.") === 0 ? "de" : host.indexOf("nl.") === 0 ? "nl" : host.indexOf("en.") === 0 ? "en" : htmlLang;
  if (!/^(fr|en|es|de|nl)$/.test(lang)) lang = "fr";

  var copy = {
    en: {
      nav: { newer: "NEW", sale: "-80%", gift: "GIFT" },
      exact: {
        "Maison européenne de lingerie féminine": "European lingerie maison",
        "Lingerie Premium": "Premium Lingerie",
        "Soutiens-gorge, ensembles et nuit élégante : confort, maintien et raffinement européen.": "Bras, sets and elegant nightwear with comfort, support and European refinement.",
        "Découvrir la sélection": "Shop the collection",
        "Voir les nouveautés": "Explore new in",
        "Livraison offerte": "Free delivery",
        "Dans nos pays sélectionnés": "To selected countries",
        "Paiement sécurisé SSL": "Secure SSL payment",
        "Paiement SSL": "SSL payment",
        "Checkout protégé et rapide": "Protected, simple checkout",
        "Suivi colis": "Tracked delivery",
        "Numéro de tracking après expédition": "Tracking number after dispatch",
        "Choix de taille aidé": "Size guidance",
        "Tableaux clairs sur les fiches": "Clear charts on product pages",
        "SÉLECTIONS SIGNATURE": "SIGNATURE EDIT",
        "Lingerie femme premium": "Premium lingerie essentials",
        "Les catégories les plus désirées pour trouver vite la coupe, la douceur et l'élégance qui vous correspondent.": "Find the fit, softness and refined style that feel made for you.",
        "Top demande": "Most wanted",
        "TOP DEMANDE": "MOST WANTED",
        "ESSENCIALS": "ESSENTIALS",
        "Culottes & bas": "Briefs & stockings",
        "Lingerie de nuit": "Nightwear",
        "Maintien": "Support",
        "Soutiens-gorge": "Bras",
        "Sculptante": "Shaping",
        "SÉLECTION HAUTE DÉSIRABILITÉ": "MOST WANTED EDIT",
        "Des produits en stock fort, choisis pour leur image, leur coupe et leur pouvoir de conversion.": "High-stock pieces chosen for fit, image and instant appeal.",
        "Voir tailles": "View sizes",
        "SOUS-VÊTEMENTS PAR ENVIE": "LINGERIE BY FEELING",
        "Bras, strings et culottes sélectionnés pour le confort, la confiance et une allure raffinée sous chaque tenue.": "Bras, thongs and briefs selected for comfort, confidence and a refined line under every outfit.",
        "Maintien doux": "Soft support",
        "Ligne invisible": "Invisible line",
        "Détail raffiné": "Refined detail",
        "Confort quotidien": "Daily comfort",
        "Dentelle délicate": "Delicate lace",
        "Maintien couture": "Couture support",
        "Allure signature": "Signature look",
        "Confort sculpté": "Sculpting comfort",
        "Silhouette naturelle et maintien rassurant.": "Natural silhouette and reassuring support.",
        "Une base invisible pour les tenues ajustées.": "An invisible base for fitted outfits.",
        "Finition discrète sous les tenues.": "A discreet finish under clothing.",
        "Une base douce pour les essentiels premium.": "A soft base for premium everyday essentials.",
        "ROBES PAR OCCASION": "DRESSES BY OCCASION",
        "Robes de soirée, robes cocktail, robes du jour et combinaisons sélectionnées pour un dîner, une cérémonie, une sortie habillée ou un moment où l'on veut se sentir remarquable.": "Evening dresses, cocktail styles, day dresses and jumpsuits chosen for dinners, ceremonies and polished moments.",
        "MARQUES EUROPÉENNES": "EUROPEAN BRANDS",
        "Des marques de lingerie, nuit, robes et dessous fabriquées en Europe, choisies pour leur coupe, leur confort et leur élégance durable.": "Lingerie, nightwear, dresses and underwear brands made in Europe or selected for fit, comfort and lasting elegance.",
        "ACHETER EN TOUTE CONFIANCE": "SHOP WITH CONFIDENCE",
        "Une expérience pensée pour réduire le doute : taille plus claire, paiement sécurisé, suivi visible et produits européens sélectionnés avec soin.": "A calmer shopping experience: clearer sizing, secure payment, visible tracking and carefully selected European pieces.",
        "AVIS CLIENTES": "CUSTOMER REVIEWS",
        "Des retours qui comptent vraiment, partagés après réception et essayage.": "Real feedback shared after delivery and fitting.",
        "CLUB SECRETELLES": "SECRETELLES CLUB",
        "-10% première commande": "-10% first order",
        "Votre sélection privée": "Your private edit",
        "Recevez une sélection intime de lingerie femme, robes, nuit élégante et conseils taille, avec des inspirations pensées pour choisir plus juste et se sentir sûre avant d'acheter.": "Receive a private edit of lingerie, dresses, elegant nightwear and fit advice to choose with confidence.",
        "Recevoir mes inspirations privées": "Email for private edits",
        "Recevoir mon accès": "Get my access",
        "PANIER SÉCURISÉ": "SECURE CART",
        "Tu bolsa": "Your bag",
        "Votre panier": "Your bag",
        "Prête pour le checkout": "Ready for checkout",
        "Paiement protégé et commande suivie après expédition.": "Protected payment and tracking after dispatch.",
        "Discount applied": "Discount applied",
        "Subtotal": "Subtotal",
        "Completar Mi Pedido": "Checkout",
        "Añade una nota a tu pedido": "Add a note to your order",
        "Livraison offerte dans nos pays sélectionnés.": "Free delivery to selected countries.",
        "This website uses cookies to ensure you get the best experience on our website.": "This website uses cookies to ensure you get the best experience on our website.",
        "Privacy Policy": "Privacy Policy",
        "Preferences": "Preferences",
        "Accept": "Accept"
      },
      fragment: {
        "réunit lingerie femme, soutiens-gorge, culottes, strings, pyjamas, nuisettes, robes et peignoirs européens, avec livraison offerte dans les pays sélectionnés.": " brings together women’s lingerie, bras, briefs, thongs, pyjamas, nightdresses, dresses and European robes, with free delivery to selected countries."
      }
    },
    es: {
      nav: { newer: "NUEVO", sale: "-80%", gift: "REGALO" },
      exact: {
        "Maison européenne de lingerie féminine": "Maison europea de lencería femenina",
        "Lingerie Premium": "Lencería premium",
        "Soutiens-gorge, ensembles et nuit élégante : confort, maintien et raffinement européen.": "Sujetadores, conjuntos y noche elegante con confort, sujeción y refinamiento europeo.",
        "Découvrir la sélection": "Descubrir la selección",
        "Voir les nouveautés": "Ver novedades",
        "Livraison offerte": "Envío gratis",
        "Dans nos pays sélectionnés": "En países seleccionados",
        "Paiement sécurisé SSL": "Pago seguro SSL",
        "Paiement SSL": "Pago SSL",
        "Checkout protégé et rapide": "Pago protegido y rápido",
        "Suivi colis": "Seguimiento",
        "Numéro de tracking après expédition": "Número de seguimiento tras el envío",
        "Choix de taille aidé": "Ayuda con la talla",
        "Tableaux clairs sur les fiches": "Guías claras en cada producto",
        "SÉLECTIONS SIGNATURE": "SELECCIÓN FIRMA",
        "Lingerie femme premium": "Lencería premium para mujer",
        "Les catégories les plus désirées pour trouver vite la coupe, la douceur et l'élégance qui vous correspondent.": "Encuentra la forma, la suavidad y el estilo refinado que encajan contigo.",
        "Top demande": "Más buscado",
        "TOP DEMANDE": "MÁS BUSCADO",
        "ESSENCIALS": "IMPRESCINDIBLES",
        "Culottes & bas": "Braguitas y medias",
        "Lingerie de nuit": "Noche elegante",
        "Maintien": "Sujeción",
        "Soutiens-gorge": "Sujetadores",
        "Sculptante": "Moldeadora",
        "SÉLECTION HAUTE DÉSIRABILITÉ": "SELECCIÓN MÁS DESEADA",
        "Des produits en stock fort, choisis pour leur image, leur coupe et leur pouvoir de conversion.": "Piezas con stock alto, elegidas por su imagen, ajuste y deseo inmediato.",
        "Voir tailles": "Ver tallas",
        "SOUS-VÊTEMENTS PAR ENVIE": "LENCERÍA SEGÚN TU MOMENTO",
        "Bras, strings et culottes sélectionnés pour le confort, la confiance et une allure raffinée sous chaque tenue.": "Sujetadores, tangas y braguitas elegidos por confort, seguridad y una línea refinada bajo cada look.",
        "Maintien doux": "Sujeción suave",
        "Ligne invisible": "Línea invisible",
        "Détail raffiné": "Detalle refinado",
        "Confort quotidien": "Confort diario",
        "Dentelle délicate": "Encaje delicado",
        "Maintien couture": "Sujeción couture",
        "Allure signature": "Estilo firma",
        "Confort sculpté": "Confort moldeador",
        "Silhouette naturelle et maintien rassurant.": "Silueta natural y sujeción segura.",
        "Une base invisible pour les tenues ajustées.": "Una base invisible para prendas ajustadas.",
        "Finition discrète sous les tenues.": "Acabado discreto bajo la ropa.",
        "Une base douce pour les essentiels premium.": "Una base suave para esenciales premium.",
        "ROBES PAR OCCASION": "VESTIDOS POR OCASIÓN",
        "Robes de soirée, robes cocktail, robes du jour et combinaisons sélectionnées pour un dîner, une cérémonie, une sortie habillée ou un moment où l'on veut se sentir remarquable.": "Vestidos de noche, cóctel, día y monos elegidos para cenas, ceremonias y ocasiones donde quieres sentirte impecable.",
        "MARQUES EUROPÉENNES": "MARCAS EUROPEAS",
        "Des marques de lingerie, nuit, robes et dessous fabriquées en Europe, choisies pour leur coupe, leur confort et leur élégance durable.": "Marcas de lencería, noche, vestidos y básicos fabricadas en Europa o elegidas por su corte, confort y elegancia duradera.",
        "ACHETER EN TOUTE CONFIANCE": "COMPRAR CON CONFIANZA",
        "Une expérience pensée pour réduire le doute : taille plus claire, paiement sécurisé, suivi visible et produits européens sélectionnés avec soin.": "Una experiencia para comprar con calma: tallas claras, pago seguro, seguimiento visible y selección europea cuidada.",
        "AVIS CLIENTES": "OPINIONES VERIFICADAS",
        "Des retours qui comptent vraiment, partagés après réception et essayage.": "Opiniones reales compartidas tras recibir y probar.",
        "CLUB SECRETELLES": "CLUB SECRETELLES",
        "-10% première commande": "-10% primer pedido",
        "Votre sélection privée": "Tu selección privada",
        "Recevez une sélection intime de lingerie femme, robes, nuit élégante et conseils taille, avec des inspirations pensées pour choisir plus juste et se sentir sûre avant d'acheter.": "Recibe una selección privada de lencería, vestidos, noche elegante y consejos de talla para elegir con seguridad.",
        "Recevoir mes inspirations privées": "Email para inspiración privada",
        "Recevoir mon accès": "Recibir mi acceso",
        "PANIER SÉCURISÉ": "CARRITO SEGURO",
        "Tu bolsa": "Tu cesta",
        "Votre panier": "Tu cesta",
        "Prête pour le checkout": "Lista para pagar",
        "Paiement protégé et commande suivie après expédition.": "Pago protegido y pedido con seguimiento tras el envío.",
        "Discount applied": "Descuento aplicado",
        "Subtotal": "Subtotal",
        "Completar Mi Pedido": "Finalizar pedido",
        "Añade una nota a tu pedido": "Añade una nota a tu pedido",
        "Livraison offerte dans nos pays sélectionnés.": "Envío gratuito a países seleccionados.",
        "This website uses cookies to ensure you get the best experience on our website.": "Esta web utiliza cookies para ofrecerte la mejor experiencia.",
        "Privacy Policy": "Política de privacidad",
        "Preferences": "Preferencias",
        "Accept": "Aceptar"
      },
      fragment: {
        "réunit lingerie femme, soutiens-gorge, culottes, strings, pyjamas, nuisettes, robes et peignoirs européens, avec livraison offerte dans les pays sélectionnés.": " reúne lencería femenina, sujetadores, braguitas, tangas, pijamas, camisones, vestidos y batas europeas, con envío gratuito a países seleccionados."
      }
    },
    de: {
      nav: { newer: "NEU", sale: "-80%", gift: "GESCHENK" },
      exact: {
        "Maison européenne de lingerie féminine": "Europäische Dessous-Maison",
        "Lingerie Premium": "Premium-Dessous",
        "Soutiens-gorge, ensembles et nuit élégante : confort, maintien et raffinement européen.": "BHs, Sets und elegante Nachtwäsche mit Komfort, Halt und europäischer Raffinesse.",
        "Découvrir la sélection": "Kollektion entdecken",
        "Voir les nouveautés": "Neuheiten ansehen",
        "Livraison offerte": "Kostenloser Versand",
        "Dans nos pays sélectionnés": "In ausgewählte Länder",
        "Paiement sécurisé SSL": "Sichere SSL-Zahlung",
        "Paiement SSL": "SSL-Zahlung",
        "Checkout protégé et rapide": "Geschützter Checkout",
        "Suivi colis": "Sendungsverfolgung",
        "Numéro de tracking après expédition": "Trackingnummer nach Versand",
        "Choix de taille aidé": "Größenberatung",
        "Tableaux clairs sur les fiches": "Klare Tabellen auf Produktseiten",
        "SÉLECTIONS SIGNATURE": "SIGNATURE-AUSWAHL",
        "Lingerie femme premium": "Premium-Dessous für Damen",
        "Les catégories les plus désirées pour trouver vite la coupe, la douceur et l'élégance qui vous correspondent.": "Finden Sie Passform, Weichheit und Eleganz, die zu Ihnen passen.",
        "Top demande": "Sehr gefragt",
        "TOP DEMANDE": "SEHR GEFRAGT",
        "ESSENCIALS": "BASICS",
        "Culottes & bas": "Slips & Strümpfe",
        "Lingerie de nuit": "Nachtwäsche",
        "Maintien": "Halt",
        "Soutiens-gorge": "BHs",
        "Sculptante": "Formend",
        "SÉLECTION HAUTE DÉSIRABILITÉ": "BELIEBTE AUSWAHL",
        "Des produits en stock fort, choisis pour leur image, leur coupe et leur pouvoir de conversion.": "Stark verfügbare Modelle, ausgewählt für Look, Passform und sofortige Begehrlichkeit.",
        "Voir tailles": "Größen ansehen",
        "SOUS-VÊTEMENTS PAR ENVIE": "DESSOUS NACH GEFÜHL",
        "Bras, strings et culottes sélectionnés pour le confort, la confiance et une allure raffinée sous chaque tenue.": "BHs, Strings und Slips, ausgewählt für Komfort, Vertrauen und eine gepflegte Linie unter jedem Outfit.",
        "Maintien doux": "Sanfter Halt",
        "Ligne invisible": "Unsichtbare Linie",
        "Détail raffiné": "Feines Detail",
        "Confort quotidien": "Alltagskomfort",
        "Dentelle délicate": "Zarte Spitze",
        "Maintien couture": "Couture-Halt",
        "Allure signature": "Signature-Look",
        "Confort sculpté": "Formender Komfort",
        "Silhouette naturelle et maintien rassurant.": "Natürliche Silhouette und verlässlicher Halt.",
        "Une base invisible pour les tenues ajustées.": "Eine unsichtbare Basis für figurbetonte Looks.",
        "Finition discrète sous les tenues.": "Diskretes Finish unter der Kleidung.",
        "Une base douce pour les essentiels premium.": "Eine weiche Basis für Premium-Essentials.",
        "ROBES PAR OCCASION": "KLEIDER NACH ANLASS",
        "Robes de soirée, robes cocktail, robes du jour et combinaisons sélectionnées pour un dîner, une cérémonie, une sortie habillée ou un moment où l'on veut se sentir remarquable.": "Abendkleider, Cocktailkleider, Tageskleider und Jumpsuits für Dinner, Feiern und besondere Auftritte.",
        "MARQUES EUROPÉENNES": "EUROPÄISCHE MARKEN",
        "Des marques de lingerie, nuit, robes et dessous fabriquées en Europe, choisies pour leur coupe, leur confort et leur élégance durable.": "Dessous-, Nachtwäsche- und Kleider-Marken aus Europa, ausgewählt für Passform, Komfort und zeitlose Eleganz.",
        "ACHETER EN TOUTE CONFIANCE": "SICHER EINKAUFEN",
        "Une expérience pensée pour réduire le doute : taille plus claire, paiement sécurisé, suivi visible et produits européens sélectionnés avec soin.": "Ein Einkaufserlebnis, das Zweifel reduziert: klare Größenhilfe, sichere Zahlung, sichtbare Sendungsverfolgung und sorgfältig ausgewählte europäische Produkte.",
        "AVIS CLIENTES": "KUNDENSTIMMEN",
        "Des retours qui comptent vraiment, partagés après réception et essayage.": "Echte Rückmeldungen nach Lieferung und Anprobe.",
        "CLUB SECRETELLES": "SECRETELLES CLUB",
        "-10% première commande": "-10% erste Bestellung",
        "Votre sélection privée": "Ihre private Auswahl",
        "Recevez une sélection intime de lingerie femme, robes, nuit élégante et conseils taille, avec des inspirations pensées pour choisir plus juste et se sentir sûre avant d'acheter.": "Erhalten Sie eine private Auswahl an Dessous, Kleidern, Nachtwäsche und Größenberatung für eine sichere Entscheidung.",
        "Recevoir mes inspirations privées": "E-Mail für private Inspiration",
        "Recevoir mon accès": "Zugang erhalten",
        "PANIER SÉCURISÉ": "SICHERER WARENKORB",
        "Tu bolsa": "Ihr Warenkorb",
        "Votre panier": "Ihr Warenkorb",
        "Prête pour le checkout": "Bereit zur Kasse",
        "Paiement protégé et commande suivie après expédition.": "Geschützte Zahlung und Sendungsverfolgung nach Versand.",
        "Discount applied": "Rabatt angewendet",
        "Subtotal": "Zwischensumme",
        "Completar Mi Pedido": "Zur Kasse",
        "Añade una nota a tu pedido": "Notiz zur Bestellung hinzufügen",
        "Livraison offerte dans nos pays sélectionnés.": "Kostenloser Versand in ausgewählte Länder.",
        "This website uses cookies to ensure you get the best experience on our website.": "Diese Website verwendet Cookies, damit Sie die beste Erfahrung erhalten.",
        "Privacy Policy": "Datenschutz",
        "Preferences": "Einstellungen",
        "Accept": "Akzeptieren"
      },
      fragment: {
        "réunit lingerie femme, soutiens-gorge, culottes, strings, pyjamas, nuisettes, robes et peignoirs européens, avec livraison offerte dans les pays sélectionnés.": " vereint Damen-Dessous, BHs, Slips, Strings, Pyjamas, Nachthemden, Kleider und europäische Morgenmäntel, mit kostenlosem Versand in ausgewählte Länder."
      }
    },
    nl: {
      nav: { newer: "NIEUW", sale: "-80%", gift: "CADEAU" },
      exact: {
        "Maison européenne de lingerie féminine": "Europese lingerie maison",
        "Lingerie Premium": "Premium lingerie",
        "Soutiens-gorge, ensembles et nuit élégante : confort, maintien et raffinement européen.": "BH's, sets en elegante nachtkleding met comfort, steun en Europese verfijning.",
        "Découvrir la sélection": "Bekijk de collectie",
        "Voir les nouveautés": "Bekijk nieuw binnen",
        "Livraison offerte": "Gratis verzending",
        "Dans nos pays sélectionnés": "Naar geselecteerde landen",
        "Paiement sécurisé SSL": "Veilige SSL-betaling",
        "Paiement SSL": "SSL-betaling",
        "Checkout protégé et rapide": "Veilig afrekenen",
        "Suivi colis": "Track & trace",
        "Numéro de tracking après expédition": "Trackingnummer na verzending",
        "Choix de taille aidé": "Hulp bij maatkeuze",
        "Tableaux clairs sur les fiches": "Heldere maattabellen per product",
        "SÉLECTIONS SIGNATURE": "SIGNATURE SELECTIE",
        "Lingerie femme premium": "Premium dameslingerie",
        "Les catégories les plus désirées pour trouver vite la coupe, la douceur et l'élégance qui vous correspondent.": "Vind snel de pasvorm, zachtheid en stijl die bij u past.",
        "Top demande": "Meest gewild",
        "TOP DEMANDE": "MEEST GEWILD",
        "ESSENCIALS": "ESSENTIALS",
        "Culottes & bas": "Slips & kousen",
        "Lingerie de nuit": "Nachtmode",
        "Maintien": "Steun",
        "Soutiens-gorge": "BH's",
        "Sculptante": "Vormend",
        "SÉLECTION HAUTE DÉSIRABILITÉ": "GELIEFDE SELECTIE",
        "Des produits en stock fort, choisis pour leur image, leur coupe et leur pouvoir de conversion.": "Ruim beschikbare items, gekozen voor uitstraling, pasvorm en directe aantrekkingskracht.",
        "Voir tailles": "Maten bekijken",
        "SOUS-VÊTEMENTS PAR ENVIE": "LINGERIE PER GEVOEL",
        "Bras, strings et culottes sélectionnés pour le confort, la confiance et une allure raffinée sous chaque tenue.": "BH's, strings en slips gekozen voor comfort, vertrouwen en een verfijnde lijn onder elke outfit.",
        "Maintien doux": "Zachte steun",
        "Ligne invisible": "Onzichtbare lijn",
        "Détail raffiné": "Verfijnd detail",
        "Confort quotidien": "Dagelijks comfort",
        "Dentelle délicate": "Fijne kant",
        "Maintien couture": "Couture steun",
        "Allure signature": "Signature look",
        "Confort sculpté": "Vormend comfort",
        "Silhouette naturelle et maintien rassurant.": "Natuurlijke lijn en betrouwbare steun.",
        "Une base invisible pour les tenues ajustées.": "Een onzichtbare basis voor aansluitende looks.",
        "Finition discrète sous les tenues.": "Discrete afwerking onder kleding.",
        "Une base douce pour les essentiels premium.": "Een zachte basis voor premium essentials.",
        "ROBES PAR OCCASION": "JURKEN PER MOMENT",
        "Robes de soirée, robes cocktail, robes du jour et combinaisons sélectionnées pour un dîner, une cérémonie, une sortie habillée ou un moment où l'on veut se sentir remarquable.": "Avondjurken, cocktailjurken, dagjurken en jumpsuits voor diners, ceremonies en verzorgde momenten.",
        "MARQUES EUROPÉENNES": "EUROPESE MERKEN",
        "Des marques de lingerie, nuit, robes et dessous fabriquées en Europe, choisies pour leur coupe, leur confort et leur élégance durable.": "Lingerie-, nachtmode- en jurkenmerken uit Europa, gekozen voor pasvorm, comfort en blijvende elegantie.",
        "ACHETER EN TOUTE CONFIANCE": "MET VERTROUWEN KOPEN",
        "Une expérience pensée pour réduire le doute : taille plus claire, paiement sécurisé, suivi visible et produits européens sélectionnés avec soin.": "Een rustige winkelervaring met duidelijke maatkeuze, veilige betaling, zichtbare tracking en zorgvuldig geselecteerde Europese items.",
        "AVIS CLIENTES": "KLANTERVARINGEN",
        "Des retours qui comptent vraiment, partagés après réception et essayage.": "Echte ervaringen na ontvangst en passen.",
        "CLUB SECRETELLES": "SECRETELLES CLUB",
        "-10% première commande": "-10% eerste bestelling",
        "Votre sélection privée": "Uw privéselectie",
        "Recevez une sélection intime de lingerie femme, robes, nuit élégante et conseils taille, avec des inspirations pensées pour choisir plus juste et se sentir sûre avant d'acheter.": "Ontvang een privéselectie lingerie, jurken, elegante nachtkleding en maatadvies om met vertrouwen te kiezen.",
        "Recevoir mes inspirations privées": "E-mail voor privé-inspiratie",
        "Recevoir mon accès": "Toegang ontvangen",
        "PANIER SÉCURISÉ": "VEILIGE WINKELWAGEN",
        "Tu bolsa": "Uw winkelwagen",
        "Votre panier": "Uw winkelwagen",
        "Prête pour le checkout": "Klaar om af te rekenen",
        "Paiement protégé et commande suivie après expédition.": "Veilig betalen en volgen na verzending.",
        "Discount applied": "Korting toegepast",
        "Subtotal": "Subtotaal",
        "Completar Mi Pedido": "Afrekenen",
        "Añade una nota a tu pedido": "Voeg een bestelnotitie toe",
        "Livraison offerte dans nos pays sélectionnés.": "Gratis verzending naar geselecteerde landen.",
        "This website uses cookies to ensure you get the best experience on our website.": "Deze website gebruikt cookies voor de beste ervaring.",
        "Privacy Policy": "Privacybeleid",
        "Preferences": "Voorkeuren",
        "Accept": "Accepteren"
      },
      fragment: {
        "réunit lingerie femme, soutiens-gorge, culottes, strings, pyjamas, nuisettes, robes et peignoirs européens, avec livraison offerte dans les pays sélectionnés.": " brengt dameslingerie, BH's, slips, strings, pyjama's, nachthemden, jurken en Europese kimono's samen, met gratis verzending naar geselecteerde landen."
      }
    },
    fr: { nav: { newer: "NEW", sale: "-80%", gift: "GIFT" }, exact: {}, fragment: {} }
  };

  function norm(text) {
    return String(text || "").replace(/\s+/g, " ").trim();
  }

  function translateNode(node, pack) {
    var value = norm(node.nodeValue);
    if (!value) return;
    if (pack.exact[value]) {
      node.nodeValue = node.nodeValue.replace(value, pack.exact[value]);
      return;
    }
    Object.keys(pack.fragment || {}).forEach(function (key) {
      if (node.nodeValue.indexOf(key) !== -1) node.nodeValue = node.nodeValue.replace(key, pack.fragment[key]);
    });
  }

  function translateAll() {
    var pack = copy[lang];
    if (!pack) return;
    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        if (!node.parentElement || !norm(node.nodeValue)) return NodeFilter.FILTER_REJECT;
        if (/^(SCRIPT|STYLE|NOSCRIPT|TEXTAREA|SELECT)$/i.test(node.parentElement.tagName)) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(function (node) { translateNode(node, pack); });

    document.querySelectorAll("[placeholder],[aria-label],[title],input[value],button[value]").forEach(function (el) {
      ["placeholder", "aria-label", "title", "value"].forEach(function (attr) {
        if (!el.hasAttribute || !el.hasAttribute(attr)) return;
        var value = norm(el.getAttribute(attr));
        if (pack.exact[value]) el.setAttribute(attr, pack.exact[value]);
      });
    });
  }

  function singleHeaderBadges() {
    var pack = copy[lang] || copy.fr;
    document.querySelectorAll(".se-market-nav-badge").forEach(function (el) { el.remove(); });
    var style = document.getElementById("se-final-market-badge-style");
    if (!style) {
      style = document.createElement("style");
      style.id = "se-final-market-badge-style";
      document.head.appendChild(style);
    }
    style.textContent = [
      ".header__inline-menu a > span::after,.header__inline-menu summary > span::after{content:none!important;display:none!important;}",
      ".header__inline-menu a:hover,.header__inline-menu summary:hover{color:#e8c989!important;text-shadow:0 5px 18px rgba(232,201,137,.28);}",
      ".se-final-nav-badge{display:inline-flex;align-items:center;justify-content:center;margin-left:7px;min-width:28px;min-height:17px;padding:0 7px;border-radius:999px;font-size:9px;font-weight:850;letter-spacing:.06em;line-height:1;text-transform:uppercase;white-space:nowrap;vertical-align:middle;transform:translateY(-1px);}",
      ".se-final-nav-badge--new{background:linear-gradient(110deg,#ad2f36 0%,#ad2f36 42%,#e8c989 50%,#ad2f36 58%,#ad2f36 100%);background-size:230% 100%;color:#fff;box-shadow:0 8px 18px rgba(173,47,54,.26);animation:seBadgeShimmer 4.8s ease-in-out infinite;}",
      ".se-final-nav-badge--sale{background:#ad2f36;color:#fff;border:1px solid rgba(232,201,137,.85);box-shadow:0 8px 18px rgba(173,47,54,.24);}",
      ".se-final-nav-badge--gift{background:rgba(255,250,247,.94);color:#4a2d5a;border:1px solid rgba(232,201,137,.9);box-shadow:0 8px 18px rgba(24,12,30,.12);}"
    ].join("");

    function one(selectors, cls, label) {
      var target = null;
      selectors.some(function (selector) {
        var link = document.querySelector(selector);
        if (!link) return false;
        target = link;
        return true;
      });
      if (!target) return;
      document.querySelectorAll(".se-final-nav-badge--" + cls).forEach(function (badge) {
        if (!target.contains(badge)) badge.remove();
      });
      var span = target.querySelector(".se-final-nav-badge--" + cls);
      if (!span) {
        span = document.createElement("span");
        span.className = "se-final-nav-badge se-final-nav-badge--" + cls;
        target.appendChild(span);
      }
      span.textContent = label;
    }

    one([
      '.header__inline-menu a[href*="nouveautes"]',
      '.header__inline-menu a[href*="new-in"]',
      '.header__inline-menu a[href*="novedades"]',
      '.header__inline-menu a[href*="neuheiten"]',
      '.header__inline-menu a[href*="nieuw-binnen"]'
    ], "new", pack.nav.newer);
    one([
      '.header__inline-menu a[href*="soldes"]',
      '.header__inline-menu a[href*="sale"]',
      '.header__inline-menu a[href*="rebajas"]',
      '.header__inline-menu a[href*="uitverkoop"]'
    ], "sale", pack.nav.sale);
    one([
      '.header__inline-menu a[href*="idees-cadeaux"]',
      '.header__inline-menu a[href*="gift-ideas"]',
      '.header__inline-menu a[href*="ideas-regalo"]',
      '.header__inline-menu a[href*="geschenkideen"]',
      '.header__inline-menu a[href*="cadeau"]'
    ], "gift", pack.nav.gift);
  }

  function run() {
    translateAll();
    singleHeaderBadges();
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", run);
  else run();
  setTimeout(run, 200);
  setTimeout(run, 900);
  setTimeout(run, 2200);
  var seFinalBadgeTimer;
  new MutationObserver(function () {
    window.clearTimeout(seFinalBadgeTimer);
    seFinalBadgeTimer = window.setTimeout(run, 80);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();

/* secretelles deep market homepage + cart localization 2026-05-20 */
(function () {
  function ready(fn) {
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", fn);
    else fn();
  }

  var lang = (document.documentElement.lang || "fr").slice(0, 2).toLowerCase();
  var market = {
    fr: {
      newBadge: "NEW",
      giftBadge: "GIFT",
      saleLabel: "-80%",
      dict: {}
    },
    en: {
      newBadge: "NEW",
      giftBadge: "GIFT",
      saleLabel: "-80%",
      dict: {
        "TOP DEMANDE": "MOST WANTED",
        "ESSENCIALS": "ESSENTIALS",
        "ESSENTIELS": "ESSENTIALS",
        "CULOTTES & BAS": "BRIEFS & HOSIERY",
        "LINGERIE DE NUIT": "NIGHTWEAR",
        "MAINTEIN": "SUPPORT",
        "MAINTIEN": "SUPPORT",
        "SOUTIENS-GORGE": "BRAS",
        "SILOUHEUTTE": "SILHOUETTE",
        "Silhouette": "Silhouette",
        "Sculptante": "Shaping",
        "Des produits en stock fort, choisis pour leur image, leur coupe et leur pouvoir de conversion.": "High-availability favourites chosen for their image, fit and buying confidence.",
        "Voir tailles": "View sizes",
        "Bras, strings et culottes sélectionnés pour le confort, la confiance et une allure raffinée sous chaque tenue.": "Bras, thongs and briefs selected for comfort, confidence and a refined line under every outfit.",
        "Silhouette naturelle et maintien rassurant.": "Natural silhouette with reassuring support.",
        "Sans bretelles pour robes et tops élégants.": "Strapless support for dresses and elegant tops.",
        "Finition discrète sous les tenues.": "Discreet finish under clothing.",
        "Tulle noir Gorteks, base chic et fiable.": "Black Gorteks tulle, chic and reliable.",
        "Base élégante en dentelle Gorteks.": "Elegant Gorteks lace essential.",
        "Maintien premium et finition couture.": "Premium support with a couture finish.",
        "Allure Axami expressive et raffinée.": "Expressive, refined Axami style.",
        "Ligne Gaia féminine et harmonieuse.": "Feminine, harmonious Gaia line.",
        "Robes de soirée, robes cocktail, robes du jour et combinaisons sélectionnées pour un dîner, une cérémonie, une sortie habillée ou un moment où l'on veut se sentir remarquable.": "Evening dresses, cocktail dresses, day dresses and jumpsuits chosen for dinners, ceremonies and polished occasions.",
        "Satin cérémonie": "Occasion satin",
        "Gala raffiné": "Refined gala",
        "Cocktail noir": "Black cocktail",
        "Cocktail chic": "Chic cocktail",
        "Combinaison habillée": "Dressy jumpsuit",
        "Robe du jour": "Day dress",
        "Occasions habillées": "Polished occasions",
        "Prête pour chaque occasion": "Ready for every occasion",
        "Satin fluide pour une présence élégante.": "Fluid satin for an elegant presence.",
        "Longue ligne féminine pour cérémonie.": "A long feminine line for ceremonies.",
        "Noir chic pour dîner ou réception.": "Chic black for dinner or reception.",
        "Vert raffiné pour une sortie habillée.": "Refined green for a polished outing.",
        "Alternative fluide à la robe du soir.": "A fluid alternative to the evening dress.",
        "Robe du jour élégante pour rester chic.": "An elegant day dress for effortless polish.",
        "Des marques de lingerie, nuit, robes et dessous fabriquées en Europe, choisies pour leur coupe, leur confort et leur élégance durable.": "European lingerie, nightwear and dress labels selected for fit, comfort and lasting elegance.",
        "Porter mieux. Se sentir libre.": "Wear better. Feel at ease.",
        "Une expérience pensée pour réduire le doute : taille plus claire, paiement sécurisé, suivi visible et produits européens sélectionnés avec soin.": "A calmer shopping experience with clearer sizing, secure payment, visible tracking and carefully selected European pieces.",
        "Choisir sa taille sans stress": "Choose your size with ease",
        "Guides clairs et fiches produits structurées pour comparer coupe, maintien et matière avant d'ajouter au panier.": "Clear guides and structured product pages to compare fit, support and fabric before adding to cart.",
        "Achat discret et maîtrisé": "Discreet, controlled shopping",
        "Parcours calme, paiement sécurisé et informations essentielles visibles au bon moment, sans pression inutile.": "A calm journey, secure payment and essential information shown at the right time.",
        "Livraison suivie": "Tracked delivery",
        "Livraison offerte dans les pays sélectionnés, avec numéro de suivi après expédition pour garder le contrôle.": "Free delivery to selected countries, with tracking after dispatch.",
        "Élégance fabriquée en Europe": "European elegance",
        "Marques européennes choisies pour le confort, la coupe et la finition, afin d'acheter une pièce que l'on porte vraiment.": "European brands chosen for comfort, fit and finish, so every piece earns its place.",
        "Des retours qui comptent vraiment, partagés après réception et essayage.": "Real feedback after delivery and fitting.",
        "Secretelles réunit lingerie femme, soutiens-gorge, culottes, strings, pyjamas, nuisettes, robes et peignoirs européens, avec livraison offerte dans les pays sélectionnés.": "Secretelles brings together women’s lingerie, bras, briefs, thongs, pyjamas, nightdresses, dresses and European robes, with free delivery to selected countries.",
        "Paiement sécurisé, livraison suivie et emballage préparé avec soin.": "Secure payment, tracked delivery and carefully prepared packaging.",
        "Livraison offerte dans nos pays sélectionnés.": "Free delivery to selected countries.",
        "Checkout protégé": "Protected checkout",
        "Votre panier": "Your basket",
        "Panier": "Basket",
        "Articles dans votre panier": "Items in your basket",
        "Produit": "Product",
        "Quantité": "Quantity",
        "Sous-total": "Subtotal",
        "Total estimé": "Estimated total",
        "Finaliser la commande": "Checkout",
        "Mettre à jour le panier": "Update basket",
        "Votre panier est actuellement vide.": "Your basket is currently empty.",
        "Continuer votre découverte": "Continue browsing"
      }
    },
    es: {
      newBadge: "NUEVO",
      giftBadge: "REGALO",
      saleLabel: "-80%",
      dict: {
        "TOP DEMANDE": "MÁS DESEADO",
        "ESSENCIALS": "IMPRESCINDIBLES",
        "ESSENTIELS": "IMPRESCINDIBLES",
        "CULOTTES & BAS": "BRAGUITAS Y MEDIAS",
        "LINGERIE DE NUIT": "LENCERÍA DE NOCHE",
        "MAINTEIN": "SUJECIÓN",
        "MAINTIEN": "SUJECIÓN",
        "SOUTIENS-GORGE": "SUJETADORES",
        "SILOUHEUTTE": "SILUETA",
        "Silhouette": "Silueta",
        "Sculptante": "Moldeadora",
        "Des produits en stock fort, choisis pour leur image, leur coupe et leur pouvoir de conversion.": "Favoritos con alta disponibilidad, elegidos por imagen, corte y confianza de compra.",
        "Voir tailles": "Ver tallas",
        "Bras, strings et culottes sélectionnés pour le confort, la confiance et une allure raffinée sous chaque tenue.": "Sujetadores, tangas y braguitas seleccionados por comodidad, confianza y una línea refinada bajo cada look.",
        "Silhouette naturelle et maintien rassurant.": "Silueta natural con sujeción segura.",
        "Sans bretelles pour robes et tops élégants.": "Sin tirantes para vestidos y tops elegantes.",
        "Finition discrète sous les tenues.": "Acabado discreto bajo la ropa.",
        "Tulle noir Gorteks, base chic et fiable.": "Tul negro Gorteks, elegante y fiable.",
        "Base élégante en dentelle Gorteks.": "Base elegante de encaje Gorteks.",
        "Maintien premium et finition couture.": "Sujeción premium con acabado de costura.",
        "Allure Axami expressive et raffinée.": "Estilo Axami expresivo y refinado.",
        "Ligne Gaia féminine et harmonieuse.": "Línea Gaia femenina y armoniosa.",
        "Robes de soirée, robes cocktail, robes du jour et combinaisons sélectionnées pour un dîner, une cérémonie, une sortie habillée ou un moment où l'on veut se sentir remarquable.": "Vestidos de noche, cóctel, día y monos para cenas, ceremonias y ocasiones en las que quieres sentirte impecable.",
        "Satin cérémonie": "Satén de ceremonia",
        "Gala raffiné": "Gala refinada",
        "Cocktail noir": "Cóctel negro",
        "Cocktail chic": "Cóctel chic",
        "Combinaison habillée": "Mono elegante",
        "Robe du jour": "Vestido de día",
        "Occasions habillées": "Ocasiones especiales",
        "Prête pour chaque occasion": "Lista para cada ocasión",
        "Satin fluide pour une présence élégante.": "Satén fluido para una presencia elegante.",
        "Longue ligne féminine pour cérémonie.": "Línea larga y femenina para ceremonia.",
        "Noir chic pour dîner ou réception.": "Negro chic para cena o recepción.",
        "Vert raffiné pour une sortie habillée.": "Verde refinado para una salida elegante.",
        "Alternative fluide à la robe du soir.": "Alternativa fluida al vestido de noche.",
        "Robe du jour élégante pour rester chic.": "Vestido de día elegante para un estilo cuidado.",
        "Des marques de lingerie, nuit, robes et dessous fabriquées en Europe, choisies pour leur coupe, leur confort et leur élégance durable.": "Marcas europeas de lencería, noche y vestidos elegidas por corte, comodidad y elegancia duradera.",
        "Porter mieux. Se sentir libre.": "Elegir mejor. Sentirse segura.",
        "Une expérience pensée pour réduire le doute : taille plus claire, paiement sécurisé, suivi visible et produits européens sélectionnés avec soin.": "Una experiencia pensada para comprar con calma: tallas claras, pago seguro, seguimiento visible y piezas europeas seleccionadas con cuidado.",
        "Choisir sa taille sans stress": "Elegir talla sin dudas",
        "Guides clairs et fiches produits structurées pour comparer coupe, maintien et matière avant d'ajouter au panier.": "Guías claras y fichas organizadas para comparar corte, sujeción y tejido antes de añadir al carrito.",
        "Achat discret et maîtrisé": "Compra discreta y segura",
        "Parcours calme, paiement sécurisé et informations essentielles visibles au bon moment, sans pression inutile.": "Un recorrido tranquilo con pago seguro e información esencial en el momento adecuado.",
        "Livraison suivie": "Envío con seguimiento",
        "Livraison offerte dans les pays sélectionnés, avec numéro de suivi après expédition pour garder le contrôle.": "Envío gratuito a países seleccionados con número de seguimiento tras la expedición.",
        "Élégance fabriquée en Europe": "Elegancia europea",
        "Marques européennes choisies pour le confort, la coupe et la finition, afin d'acheter une pièce que l'on porte vraiment.": "Marcas europeas elegidas por comodidad, corte y acabado, para comprar piezas que realmente se usan.",
        "Des retours qui comptent vraiment, partagés après réception et essayage.": "Opiniones reales después de recibir y probar.",
        "Secretelles réunit lingerie femme, soutiens-gorge, culottes, strings, pyjamas, nuisettes, robes et peignoirs européens, avec livraison offerte dans les pays sélectionnés.": "Secretelles reúne lencería femenina, sujetadores, braguitas, tangas, pijamas, camisones, vestidos y batas europeas, con envío gratuito a países seleccionados.",
        "Paiement sécurisé, livraison suivie et emballage préparé avec soin.": "Pago seguro, envío con seguimiento y embalaje preparado con cuidado.",
        "Livraison offerte dans nos pays sélectionnés.": "Envío gratuito a países seleccionados.",
        "Checkout protégé": "Pago protegido",
        "Votre panier": "Tu carrito",
        "Panier": "Carrito",
        "Articles dans votre panier": "Artículos en tu carrito",
        "Produit": "Producto",
        "Quantité": "Cantidad",
        "Sous-total": "Subtotal",
        "Total estimé": "Total estimado",
        "Finaliser la commande": "Finalizar compra",
        "Mettre à jour le panier": "Actualizar carrito",
        "Votre panier est actuellement vide.": "Tu carrito está vacío.",
        "Continuer votre découverte": "Seguir descubriendo"
      }
    },
    de: {
      newBadge: "NEU",
      giftBadge: "GESCHENK",
      saleLabel: "-80%",
      dict: {
        "TOP DEMANDE": "SEHR GEFRAGT",
        "ESSENCIALS": "ESSENTIALS",
        "ESSENTIELS": "ESSENTIALS",
        "CULOTTES & BAS": "SLIPS & STRÜMPFE",
        "LINGERIE DE NUIT": "NACHTWÄSCHE",
        "MAINTEIN": "HALT",
        "MAINTIEN": "HALT",
        "SOUTIENS-GORGE": "BHs",
        "SILOUHEUTTE": "SILHOUETTE",
        "Silhouette": "Silhouette",
        "Sculptante": "Formend",
        "Des produits en stock fort, choisis pour leur image, leur coupe et leur pouvoir de conversion.": "Verfügbare Favoriten, ausgewählt nach Wirkung, Passform und Kaufvertrauen.",
        "Voir tailles": "Größen ansehen",
        "Bras, strings et culottes sélectionnés pour le confort, la confiance et une allure raffinée sous chaque tenue.": "BHs, Strings und Slips, ausgewählt für Komfort, sicheren Halt und eine elegante Linie unter jeder Kleidung.",
        "Silhouette naturelle et maintien rassurant.": "Natürliche Silhouette mit verlässlichem Halt.",
        "Sans bretelles pour robes et tops élégants.": "Trägerlos für Kleider und elegante Tops.",
        "Finition discrète sous les tenues.": "Diskrete Verarbeitung unter feiner Kleidung.",
        "Tulle noir Gorteks, base chic et fiable.": "Schwarzer Tüll von Gorteks, schick und zuverlässig.",
        "Base élégante en dentelle Gorteks.": "Elegante Spitzenbasis von Gorteks.",
        "Maintien premium et finition couture.": "Premium-Halt mit Couture-Finish.",
        "Allure Axami expressive et raffinée.": "Ausdrucksstarker, raffinierter Axami-Look.",
        "Ligne Gaia féminine et harmonieuse.": "Feminine, harmonische Linie von Gaia.",
        "Robes de soirée, robes cocktail, robes du jour et combinaisons sélectionnées pour un dîner, une cérémonie, une sortie habillée ou un moment où l'on veut se sentir remarquable.": "Abendkleider, Cocktailkleider, Tageskleider und Jumpsuits für Dinner, Feiern und besondere Auftritte.",
        "Satin cérémonie": "Satin für Anlässe",
        "Gala raffiné": "Raffinierter Gala-Look",
        "Cocktail noir": "Schwarzer Cocktail-Look",
        "Cocktail chic": "Chicer Cocktail-Look",
        "Combinaison habillée": "Eleganter Jumpsuit",
        "Robe du jour": "Tageskleid",
        "Occasions habillées": "Elegante Anlässe",
        "Prête pour chaque occasion": "Bereit für jeden Anlass",
        "Satin fluide pour une présence élégante.": "Fließender Satin für einen eleganten Auftritt.",
        "Longue ligne féminine pour cérémonie.": "Lange feminine Linie für festliche Momente.",
        "Noir chic pour dîner ou réception.": "Chices Schwarz für Dinner und Empfang.",
        "Vert raffiné pour une sortie habillée.": "Raffiniertes Grün für einen eleganten Auftritt.",
        "Alternative fluide à la robe du soir.": "Fließende Alternative zum Abendkleid.",
        "Robe du jour élégante pour rester chic.": "Elegantes Tageskleid für einen gepflegten Look.",
        "Des marques de lingerie, nuit, robes et dessous fabriquées en Europe, choisies pour leur coupe, leur confort et leur élégance durable.": "Europäische Dessous-, Nachtwäsche- und Kleidermarken, ausgewählt für Passform, Komfort und dauerhafte Eleganz.",
        "Porter mieux. Se sentir libre.": "Besser wählen. Freier tragen.",
        "Une expérience pensée pour réduire le doute : taille plus claire, paiement sécurisé, suivi visible et produits européens sélectionnés avec soin.": "Ein Einkaufserlebnis, das Zweifel reduziert: klare Größenhilfe, sichere Zahlung, sichtbare Sendungsverfolgung und sorgfältig ausgewählte europäische Produkte.",
        "Choisir sa taille sans stress": "Größe ohne Stress wählen",
        "Guides clairs et fiches produits structurées pour comparer coupe, maintien et matière avant d'ajouter au panier.": "Klare Guides und strukturierte Produktseiten, um Schnitt, Halt und Material vor dem Warenkorb zu vergleichen.",
        "Achat discret et maîtrisé": "Diskret und sicher einkaufen",
        "Parcours calme, paiement sécurisé et informations essentielles visibles au bon moment, sans pression inutile.": "Ruhiger Kaufprozess, sichere Zahlung und die wichtigsten Informationen genau im richtigen Moment.",
        "Livraison suivie": "Lieferung mit Tracking",
        "Livraison offerte dans les pays sélectionnés, avec numéro de suivi après expédition pour garder le contrôle.": "Kostenloser Versand in ausgewählte Länder mit Sendungsnummer nach dem Versand.",
        "Élégance fabriquée en Europe": "Europäische Eleganz",
        "Marques européennes choisies pour le confort, la coupe et la finition, afin d'acheter une pièce que l'on porte vraiment.": "Europäische Marken, gewählt für Komfort, Passform und Verarbeitung, damit jedes Stück wirklich getragen wird.",
        "Des retours qui comptent vraiment, partagés après réception et essayage.": "Echte Rückmeldungen nach Erhalt und Anprobe.",
        "Secretelles réunit lingerie femme, soutiens-gorge, culottes, strings, pyjamas, nuisettes, robes et peignoirs européens, avec livraison offerte dans les pays sélectionnés.": "Secretelles vereint Damen-Dessous, BHs, Slips, Strings, Pyjamas, Nachthemden, Kleider und europäische Morgenmäntel mit kostenlosem Versand in ausgewählte Länder.",
        "Paiement sécurisé, livraison suivie et emballage préparé avec soin.": "Sichere Zahlung, Lieferung mit Tracking und sorgfältig vorbereitete Verpackung.",
        "Livraison offerte dans nos pays sélectionnés.": "Kostenloser Versand in ausgewählte Länder.",
        "Checkout protégé": "Geschützter Checkout",
        "Votre panier": "Ihr Warenkorb",
        "Panier": "Warenkorb",
        "Articles dans votre panier": "Artikel in Ihrem Warenkorb",
        "Produit": "Produkt",
        "Quantité": "Menge",
        "Sous-total": "Zwischensumme",
        "Total estimé": "Geschätzter Gesamtbetrag",
        "Finaliser la commande": "Zur Kasse",
        "Mettre à jour le panier": "Warenkorb aktualisieren",
        "Votre panier est actuellement vide.": "Ihr Warenkorb ist noch leer.",
        "Continuer votre découverte": "Weiter entdecken"
      }
    },
    nl: {
      newBadge: "NIEUW",
      giftBadge: "CADEAU",
      saleLabel: "-80%",
      dict: {
        "TOP DEMANDE": "MEEST GEWILD",
        "ESSENCIALS": "ESSENTIALS",
        "ESSENTIELS": "ESSENTIALS",
        "CULOTTES & BAS": "SLIPS & KOUSEN",
        "LINGERIE DE NUIT": "NACHTMODE",
        "MAINTEIN": "STEUN",
        "MAINTIEN": "STEUN",
        "SOUTIENS-GORGE": "BH's",
        "SILOUHEUTTE": "SILHOUET",
        "Silhouette": "Silhouet",
        "Sculptante": "Vormend",
        "Des produits en stock fort, choisis pour leur image, leur coupe et leur pouvoir de conversion.": "Favorieten met ruime voorraad, gekozen om uitstraling, pasvorm en koopvertrouwen.",
        "Voir tailles": "Maten bekijken",
        "Bras, strings et culottes sélectionnés pour le confort, la confiance et une allure raffinée sous chaque tenue.": "BH's, strings en slips geselecteerd voor comfort, vertrouwen en een verfijnde lijn onder elke outfit.",
        "Silhouette naturelle et maintien rassurant.": "Natuurlijk silhouet met betrouwbare steun.",
        "Sans bretelles pour robes et tops élégants.": "Strapless voor jurken en elegante tops.",
        "Finition discrète sous les tenues.": "Discrete afwerking onder kleding.",
        "Tulle noir Gorteks, base chic et fiable.": "Zwarte Gorteks tule, chic en betrouwbaar.",
        "Base élégante en dentelle Gorteks.": "Elegante kanten basis van Gorteks.",
        "Maintien premium et finition couture.": "Premium steun met couture-afwerking.",
        "Allure Axami expressive et raffinée.": "Expressieve, verfijnde Axami-look.",
        "Ligne Gaia féminine et harmonieuse.": "Vrouwelijke, harmonieuze Gaia-lijn.",
        "Robes de soirée, robes cocktail, robes du jour et combinaisons sélectionnées pour un dîner, une cérémonie, une sortie habillée ou un moment où l'on veut se sentir remarquable.": "Avondjurken, cocktailjurken, dagjurken en jumpsuits voor diners, ceremonies en verzorgde momenten.",
        "Satin cérémonie": "Satijn voor gelegenheden",
        "Gala raffiné": "Verfijnde gala-look",
        "Cocktail noir": "Zwarte cocktail-look",
        "Cocktail chic": "Chique cocktail",
        "Combinaison habillée": "Elegante jumpsuit",
        "Robe du jour": "Dagjurk",
        "Occasions habillées": "Geklede momenten",
        "Prête pour chaque occasion": "Klaar voor elke gelegenheid",
        "Satin fluide pour une présence élégante.": "Vloeiend satijn voor een elegante uitstraling.",
        "Longue ligne féminine pour cérémonie.": "Lange vrouwelijke lijn voor ceremonies.",
        "Noir chic pour dîner ou réception.": "Chic zwart voor diner of receptie.",
        "Vert raffiné pour une sortie habillée.": "Verfijnd groen voor een geklede afspraak.",
        "Alternative fluide à la robe du soir.": "Vloeiend alternatief voor de avondjurk.",
        "Robe du jour élégante pour rester chic.": "Elegante dagjurk voor een verzorgde look.",
        "Des marques de lingerie, nuit, robes et dessous fabriquées en Europe, choisies pour leur coupe, leur confort et leur élégance durable.": "Europese lingerie-, nachtmode- en jurkenmerken, gekozen om pasvorm, comfort en blijvende elegantie.",
        "Porter mieux. Se sentir libre.": "Beter kiezen. Vrijer dragen.",
        "Une expérience pensée pour réduire le doute : taille plus claire, paiement sécurisé, suivi visible et produits européens sélectionnés avec soin.": "Een rustige winkelervaring met duidelijke maatkeuze, veilige betaling, zichtbare tracking en zorgvuldig geselecteerde Europese items.",
        "Choisir sa taille sans stress": "Je maat zonder twijfel kiezen",
        "Guides clairs et fiches produits structurées pour comparer coupe, maintien et matière avant d'ajouter au panier.": "Heldere gidsen en productpagina's om pasvorm, steun en materiaal te vergelijken voor je toevoegt aan de winkelmand.",
        "Achat discret et maîtrisé": "Discreet en vertrouwd shoppen",
        "Parcours calme, paiement sécurisé et informations essentielles visibles au bon moment, sans pression inutile.": "Een rustige route met veilige betaling en de juiste informatie op het juiste moment.",
        "Livraison suivie": "Levering met tracking",
        "Livraison offerte dans les pays sélectionnés, avec numéro de suivi après expédition pour garder le contrôle.": "Gratis verzending naar geselecteerde landen met trackingnummer na verzending.",
        "Élégance fabriquée en Europe": "Europese elegantie",
        "Marques européennes choisies pour le confort, la coupe et la finition, afin d'acheter une pièce que l'on porte vraiment.": "Europese merken gekozen om comfort, pasvorm en afwerking, zodat elk item echt gedragen wordt.",
        "Des retours qui comptent vraiment, partagés après réception et essayage.": "Echte reacties na ontvangst en passen.",
        "Secretelles réunit lingerie femme, soutiens-gorge, culottes, strings, pyjamas, nuisettes, robes et peignoirs européens, avec livraison offerte dans les pays sélectionnés.": "Secretelles brengt dameslingerie, BH's, slips, strings, pyjama's, nachthemden, jurken en Europese kimono's samen, met gratis verzending naar geselecteerde landen.",
        "Paiement sécurisé, livraison suivie et emballage préparé avec soin.": "Veilige betaling, levering met tracking en zorgvuldig voorbereide verpakking.",
        "Livraison offerte dans nos pays sélectionnés.": "Gratis verzending naar geselecteerde landen.",
        "Checkout protégé": "Beveiligde checkout",
        "Votre panier": "Je winkelmand",
        "Panier": "Winkelmand",
        "Articles dans votre panier": "Artikelen in je winkelmand",
        "Produit": "Product",
        "Quantité": "Aantal",
        "Sous-total": "Subtotaal",
        "Total estimé": "Geschat totaal",
        "Finaliser la commande": "Afrekenen",
        "Mettre à jour le panier": "Winkelmand bijwerken",
        "Votre panier est actuellement vide.": "Je winkelmand is nog leeg.",
        "Continuer votre découverte": "Verder ontdekken"
      }
    }
  };

  function cleanText(value) {
    return String(value || "").replace(/\s+/g, " ").trim();
  }

  function translateNode(node, dict) {
    var original = node.nodeValue;
    var text = cleanText(original);
    if (!text) return;
    var translated = dict[text];
    if (!translated) {
      Object.keys(dict).some(function (key) {
        if (text.indexOf(key) !== -1) {
          translated = original.replace(key, dict[key]);
          return true;
        }
        return false;
      });
    }
    if (translated) node.nodeValue = original.replace(text, translated);
  }

  function translateMarketCopy() {
    var config = market[lang];
    if (!config || !config.dict) return;
    var dict = config.dict;
    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        if (!node.parentElement) return NodeFilter.FILTER_REJECT;
        var tag = node.parentElement.tagName;
        if (/^(SCRIPT|STYLE|NOSCRIPT|TEXTAREA|INPUT|SELECT)$/i.test(tag)) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(function (node) { translateNode(node, dict); });

    document.querySelectorAll("input[placeholder], textarea[placeholder], button[aria-label], a[aria-label]").forEach(function (el) {
      ["placeholder", "aria-label"].forEach(function (attr) {
        var value = el.getAttribute(attr);
        if (dict[value]) el.setAttribute(attr, dict[value]);
      });
    });
  }

  function ensureMarketHeaderBadges() {
    var config = market[lang] || market.fr;
    document.querySelectorAll(".se-market-nav-badge").forEach(function (badge) { badge.remove(); });
    var style = document.getElementById("se-market-header-badge-style");
    if (!style) {
      style = document.createElement("style");
      style.id = "se-market-header-badge-style";
      document.head.appendChild(style);
    }
    style.textContent = [
      ".header__inline-menu > ul > li > a > span::after,.header__inline-menu a[href*='nouveautes'] > span::after,.header__inline-menu a[href*='new-in'] > span::after,.header__inline-menu a[href*='novedades'] > span::after,.header__inline-menu a[href*='neuheiten'] > span::after,.header__inline-menu a[href*='nieuw-binnen'] > span::after,.header__inline-menu a[href*='soldes'] > span::after,.header__inline-menu a[href*='sale'] > span::after,.header__inline-menu a[href*='rebajas'] > span::after,.header__inline-menu a[href*='uitverkoop'] > span::after,.header__inline-menu a[href*='idees-cadeaux'] > span::after,.header__inline-menu a[href*='gift-ideas'] > span::after,.header__inline-menu a[href*='ideas-regalo'] > span::after,.header__inline-menu a[href*='geschenkideen'] > span::after,.header__inline-menu a[href*='cadeau'] > span::after{content:none!important;display:none!important;}",
      ".se-market-nav-badge{display:inline-flex;align-items:center;justify-content:center;min-height:17px;margin-left:7px;padding:0 7px;border-radius:999px;font-size:9px;font-weight:850;letter-spacing:.045em;line-height:1;text-transform:uppercase;vertical-align:middle;white-space:nowrap;}",
      ".se-market-nav-badge--new{background:linear-gradient(110deg,#c5263f 0%,#c5263f 42%,#e8c989 50%,#c5263f 58%,#c5263f 100%);background-size:240% 100%;color:#fff;box-shadow:0 7px 16px rgba(197,38,63,.28);animation:seBadgeShimmer 4.5s ease-in-out infinite;}",
      ".se-market-nav-badge--sale{background:#c5263f;color:#fff;border:1px solid rgba(232,201,137,.78);box-shadow:0 7px 16px rgba(197,38,63,.28);animation:seBadgePulse 3.8s ease-in-out infinite;}",
      ".se-market-nav-badge--gift{background:rgba(255,250,247,.92);color:#4a2d5a;border:1px solid rgba(232,201,137,.82);box-shadow:0 7px 16px rgba(24,12,30,.14);}",
      ".header__inline-menu a:hover,.header__inline-menu summary:hover{color:#e8c989!important;text-shadow:0 4px 16px rgba(232,201,137,.30);}"
    ].join("");
    document.querySelectorAll(".se-market-nav-badge").forEach(function (badge) { badge.remove(); });
    return;

    function addBadge(selector, cls, label) {
      document.querySelectorAll(selector).forEach(function (link) {
        if (link.querySelector(".se-market-nav-badge--" + cls)) return;
        var span = document.createElement("span");
        span.className = "se-market-nav-badge se-market-nav-badge--" + cls;
        span.textContent = label;
        link.appendChild(span);
      });
    }
    addBadge('a[href*="nouveautes"],a[href*="new-in"],a[href*="novedades"],a[href*="neuheiten"],a[href*="nieuw-binnen"],a[id*="HeaderMenu-nouveautes"],a[id*="HeaderMenu-new"],a[id*="HeaderMenu-novedades"],a[id*="HeaderMenu-neuheiten"],a[id*="HeaderMenu-nieuw"]', "new", config.newBadge);
    addBadge('a[href*="soldes"],a[href*="sale"],a[href*="rebajas"],a[href*="uitverkoop"],a[id*="HeaderMenu-soldes"],a[id*="HeaderMenu-sale"],a[id*="HeaderMenu-rebajas"],a[id*="HeaderMenu-uitverkoop"]', "sale", config.saleLabel);
    addBadge('a[href*="idees-cadeaux"],a[href*="gift-ideas"],a[href*="ideas-regalo"],a[href*="geschenkideen"],a[href*="cadeau"],a[id*="HeaderMenu-idees-cadeaux"],a[id*="HeaderMenu-gift"],a[id*="HeaderMenu-ideas-regalo"],a[id*="HeaderMenu-geschenk"],a[id*="HeaderMenu-cadeau"]', "gift", config.giftBadge);
  }

  ready(function () {
    translateMarketCopy();
    ensureMarketHeaderBadges();
    setTimeout(translateMarketCopy, 250);
    setTimeout(ensureMarketHeaderBadges, 350);
  });
})();

/* secretelles_market_i18n_current_20260520 */
(function () {
  var host = window.location.hostname || "";
  var htmlLang = (document.documentElement.lang || "").slice(0, 2).toLowerCase();
  var lang = host.indexOf("es.") === 0 ? "es" : host.indexOf("de.") === 0 ? "de" : host.indexOf("nl.") === 0 ? "nl" : host.indexOf("en.") === 0 ? "en" : htmlLang;
  if (!/^(en|es|de|nl)$/.test(lang)) return;

  var dictionary = {
    en: {
      "NOUVEAUTÉS": "NEW IN",
      "LINGERIE": "LINGERIE",
      "NUIT & DÉTENTE": "NIGHTWEAR & LOUNGE",
      "ROBES & MODE": "DRESSES & FASHION",
      "NOS MARQUES": "OUR BRANDS",
      "SOLDES": "SALE",
      "IDÉES CADEAUX": "GIFT IDEAS",
      "Maison européenne de lingerie féminine": "European lingerie maison",
      "Lingerie Premium": "Premium Lingerie",
      "Soutiens-gorge, ensembles et nuit élégante : confort, maintien et raffinement européen.": "Bras, sets and elegant nightwear with comfort, support and European refinement.",
      "Découvrir la sélection": "Shop the collection",
      "Voir les nouveautés": "Explore new in",
      "Livraison offerte": "Free delivery",
      "Dans nos pays sélectionnés": "To selected countries",
      "Paiement sécurisé SSL": "SSL secure payment",
      "Checkout protégé et rapide": "Protected, simple checkout",
      "Suivi colis": "Tracked delivery",
      "Numéro de tracking après expédition": "Tracking number after dispatch",
      "Choix de taille aidé": "Size guidance",
      "Tableaux clairs sur les fiches": "Clear charts on product pages",
      "SÉLECTIONS SIGNATURE": "SIGNATURE EDIT",
      "Lingerie femme premium": "Premium lingerie essentials",
      "Les catégories les plus désirées pour trouver vite la coupe, la douceur et l'élégance qui vous correspondent.": "Find the fit, softness and refined style that feel made for you.",
      "SÉLECTION HAUTE DÉSIRABILITÉ": "MOST WANTED EDIT",
      "Pièces désirées, coupe raffinée": "Desired pieces, refined fit",
      "Une sélection de modèles en stock, choisis pour leur image, leur coupe et leur potentiel coup de cœur.": "In-stock styles chosen for their image, fit and instant appeal.",
      "SOUS-VÊTEMENTS PAR ENVIE": "LINGERIE BY FEELING",
      "Bases lingerie, allure sûre": "Confident everyday foundations",
      "Soutiens-gorge, strings et culottes choisis pour le confort, la confiance et la ligne sous chaque tenue.": "Bras, thongs and briefs selected for comfort, confidence and a smooth line.",
      "ROBES PAR OCCASION": "DRESSES BY OCCASION",
      "Robes pour chaque occasion": "Dresses for every occasion",
      "Une sélection pensée pour les dîners, cérémonies, cocktails et sorties où la coupe doit donner confiance sans effort.": "Elegant dresses for dinners, ceremonies and moments where fit should feel effortless.",
      "MARQUES EUROPÉENNES": "EUROPEAN BRANDS",
      "Maisons européennes": "European maisons",
      "Des marques fabriquées en Europe ou sélectionnées pour leur savoir-faire, leurs coupes et leurs matières raffinées.": "Brands made in Europe or chosen for craftsmanship, fit and refined fabrics.",
      "ACHETER EN TOUTE CONFIANCE": "SHOP WITH CONFIDENCE",
      "Chaque détail rassure": "Every detail reassures",
      "Un parcours pensé pour acheter facilement, choisir la bonne taille et recevoir sa commande avec suivi.": "A simple journey for choosing the right size and receiving your order with tracking.",
      "AVIS CLIENTES": "CUSTOMER REVIEWS",
      "Porté, aimé, vérifié": "Worn, loved, verified",
      "Des retours qui comptent vraiment.": "Real feedback that helps you choose with confidence.",
      "CLUB SECRETELLES": "SECRETELLES CLUB",
      "-10% première commande": "-10% first order",
      "Votre sélection privée": "Your private edit",
      "Recevez une sélection intime de lingerie femme, robes, nuit élégante et conseils taille, avec des inspirations pensées pour choisir plus juste et se sentir sûre avant d'acheter.": "Receive a refined private edit of lingerie, dresses, elegant nightwear and fit advice to choose with confidence.",
      "Recevoir mes inspirations privées": "Enter your email for private edits",
      "Recevoir mon accès": "Get my access",
      "Offre spéciale": "Special offer",
      "Vérifié": "Verified",
      "Guide des tailles": "Size guide",
      "Taille": "Size",
      "Couleur": "Colour",
      "Prix": "Price",
      "Description": "Description",
      "Ajouter au panier": "Add to cart",
      "Acheter maintenant": "Buy now",
      "Votre panier": "Your cart",
      "Total": "Total",
      "Commander": "Checkout",
      "Continuer mes achats": "Continue shopping",
      "Livraison offerte dans nos pays sélectionnés": "Free delivery to selected countries"
    },
    es: {
      "NOUVEAUTÉS": "NOVEDADES",
      "LINGERIE": "LENCERÍA",
      "NUIT & DÉTENTE": "NOCHE & RELAX",
      "ROBES & MODE": "VESTIDOS & MODA",
      "NOS MARQUES": "NUESTRAS MARCAS",
      "SOLDES": "REBAJAS",
      "IDÉES CADEAUX": "IDEAS REGALO",
      "Maison européenne de lingerie féminine": "Maison europea de lencería femenina",
      "Lingerie Premium": "Lencería Premium",
      "Soutiens-gorge, ensembles et nuit élégante : confort, maintien et raffinement européen.": "Sujetadores, conjuntos y noche elegante con comodidad, sujeción y refinamiento europeo.",
      "Découvrir la sélection": "Descubrir la selección",
      "Voir les nouveautés": "Ver novedades",
      "Livraison offerte": "Envío gratis",
      "Dans nos pays sélectionnés": "En países seleccionados",
      "Paiement sécurisé SSL": "Pago seguro SSL",
      "Checkout protégé et rapide": "Compra protegida y rápida",
      "Suivi colis": "Seguimiento del pedido",
      "Numéro de tracking après expédition": "Número de seguimiento tras el envío",
      "Choix de taille aidé": "Ayuda de talla",
      "Tableaux clairs sur les fiches": "Guías claras en cada producto",
      "SÉLECTIONS SIGNATURE": "SELECCIÓN FIRMA",
      "Lingerie femme premium": "Lencería premium femenina",
      "Les catégories les plus désirées pour trouver vite la coupe, la douceur et l'élégance qui vous correspondent.": "Encuentra rápido la forma, suavidad y elegancia que encajan contigo.",
      "SÉLECTION HAUTE DÉSIRABILITÉ": "SELECCIÓN MÁS DESEADA",
      "Pièces désirées, coupe raffinée": "Prendas deseadas, corte refinado",
      "Une sélection de modèles en stock, choisis pour leur image, leur coupe et leur potentiel coup de cœur.": "Modelos en stock elegidos por su imagen, corte y efecto flechazo.",
      "SOUS-VÊTEMENTS PAR ENVIE": "LENCERÍA SEGÚN TU MOMENTO",
      "Bases lingerie, allure sûre": "Bases íntimas para sentirte segura",
      "Soutiens-gorge, strings et culottes choisis pour le confort, la confiance et la ligne sous chaque tenue.": "Sujetadores, tangas y braguitas para comodidad, confianza y una línea limpia.",
      "ROBES PAR OCCASION": "VESTIDOS POR OCASIÓN",
      "Robes pour chaque occasion": "Vestidos para cada ocasión",
      "Une sélection pensée pour les dîners, cérémonies, cocktails et sorties où la coupe doit donner confiance sans effort.": "Vestidos para cenas, ceremonias y salidas donde el corte aporta seguridad.",
      "MARQUES EUROPÉENNES": "MARCAS EUROPEAS",
      "Maisons européennes": "Casas europeas",
      "Des marques fabriquées en Europe ou sélectionnées pour leur savoir-faire, leurs coupes et leurs matières raffinées.": "Marcas fabricadas en Europa o elegidas por su saber hacer, cortes y tejidos.",
      "ACHETER EN TOUTE CONFIANCE": "COMPRAR CON CONFIANZA",
      "Chaque détail rassure": "Cada detalle da tranquilidad",
      "Un parcours pensé pour acheter facilement, choisir la bonne taille et recevoir sa commande avec suivi.": "Una compra sencilla para elegir talla y recibir tu pedido con seguimiento.",
      "AVIS CLIENTES": "OPINIONES VERIFICADAS",
      "Porté, aimé, vérifié": "Probado, amado, verificado",
      "Des retours qui comptent vraiment.": "Opiniones reales que ayudan a elegir con confianza.",
      "CLUB SECRETELLES": "CLUB SECRETELLES",
      "-10% première commande": "-10% primer pedido",
      "Votre sélection privée": "Tu selección privada",
      "Recevez une sélection intime de lingerie femme, robes, nuit élégante et conseils taille, avec des inspirations pensées pour choisir plus juste et se sentir sûre avant d'acheter.": "Recibe una selección privada de lencería, vestidos, noche elegante y consejos de talla para comprar con seguridad.",
      "Recevoir mes inspirations privées": "Tu email para inspiración privada",
      "Recevoir mon accès": "Recibir mi acceso",
      "Offre spéciale": "Oferta especial",
      "Vérifié": "Verificado",
      "Guide des tailles": "Guía de tallas",
      "Taille": "Talla",
      "Couleur": "Color",
      "Prix": "Precio",
      "Description": "Descripción",
      "Ajouter au panier": "Añadir al carrito",
      "Acheter maintenant": "Comprar ahora",
      "Votre panier": "Tu carrito",
      "Total": "Total",
      "Commander": "Finalizar compra",
      "Continuer mes achats": "Seguir comprando",
      "Livraison offerte dans nos pays sélectionnés": "Envío gratuito en países seleccionados"
    },
    de: {
      "NOUVEAUTÉS": "NEUHEITEN",
      "LINGERIE": "DESSOUS",
      "NUIT & DÉTENTE": "NACHT & LOUNGE",
      "ROBES & MODE": "KLEIDER & MODE",
      "NOS MARQUES": "UNSERE MARKEN",
      "SOLDES": "SALE",
      "IDÉES CADEAUX": "GESCHENKIDEEN",
      "Maison européenne de lingerie féminine": "Europäische Dessous-Maison",
      "Lingerie Premium": "Premium-Dessous",
      "Soutiens-gorge, ensembles et nuit élégante : confort, maintien et raffinement européen.": "BHs, Sets und elegante Nachtwäsche mit Komfort, Halt und europäischer Raffinesse.",
      "Découvrir la sélection": "Kollektion entdecken",
      "Voir les nouveautés": "Neuheiten ansehen",
      "Livraison offerte": "Kostenloser Versand",
      "Dans nos pays sélectionnés": "In ausgewählte Länder",
      "Paiement sécurisé SSL": "Sichere SSL-Zahlung",
      "Checkout protégé et rapide": "Geschützter, schneller Checkout",
      "Suivi colis": "Sendungsverfolgung",
      "Numéro de tracking après expédition": "Trackingnummer nach Versand",
      "Choix de taille aidé": "Größenberatung",
      "Tableaux clairs sur les fiches": "Klare Tabellen auf Produktseiten",
      "SÉLECTIONS SIGNATURE": "SIGNATURE-AUSWAHL",
      "Lingerie femme premium": "Premium-Dessous für Damen",
      "Les catégories les plus désirées pour trouver vite la coupe, la douceur et l'élégance qui vous correspondent.": "Finden Sie Passform, Weichheit und Eleganz, die zu Ihnen passen.",
      "SÉLECTION HAUTE DÉSIRABILITÉ": "BELIEBTE AUSWAHL",
      "Pièces désirées, coupe raffinée": "Gefragte Stücke, raffinierte Passform",
      "Une sélection de modèles en stock, choisis pour leur image, leur coupe et leur potentiel coup de cœur.": "Verfügbare Modelle, ausgewählt nach Optik, Schnitt und Lieblingspotenzial.",
      "SOUS-VÊTEMENTS PAR ENVIE": "DESSOUS NACH GEFÜHL",
      "Bases lingerie, allure sûre": "Sichere Basics für jeden Tag",
      "Soutiens-gorge, strings et culottes choisis pour le confort, la confiance et la ligne sous chaque tenue.": "BHs, Strings und Slips für Komfort, Vertrauen und eine klare Silhouette.",
      "ROBES PAR OCCASION": "KLEIDER NACH ANLASS",
      "Robes pour chaque occasion": "Kleider für jeden Anlass",
      "Une sélection pensée pour les dîners, cérémonies, cocktails et sorties où la coupe doit donner confiance sans effort.": "Kleider für Dinner, Feiern und Auftritte, bei denen die Passform Sicherheit gibt.",
      "MARQUES EUROPÉENNES": "EUROPÄISCHE MARKEN",
      "Maisons européennes": "Europäische Häuser",
      "Des marques fabriquées en Europe ou sélectionnées pour leur savoir-faire, leurs coupes et leurs matières raffinées.": "Marken aus Europa oder nach Handwerk, Schnitt und edlen Materialien ausgewählt.",
      "ACHETER EN TOUTE CONFIANCE": "SICHER EINKAUFEN",
      "Chaque détail rassure": "Jedes Detail gibt Sicherheit",
      "Un parcours pensé pour acheter facilement, choisir la bonne taille et recevoir sa commande avec suivi.": "Ein einfacher Kaufweg mit Größenhilfe und verfolgbarer Lieferung.",
      "AVIS CLIENTES": "KUNDENSTIMMEN",
      "Porté, aimé, vérifié": "Getragen, geliebt, verifiziert",
      "Des retours qui comptent vraiment.": "Echte Rückmeldungen, die bei der Auswahl helfen.",
      "CLUB SECRETELLES": "SECRETELLES CLUB",
      "-10% première commande": "-10% erste Bestellung",
      "Votre sélection privée": "Ihre private Auswahl",
      "Recevez une sélection intime de lingerie femme, robes, nuit élégante et conseils taille, avec des inspirations pensées pour choisir plus juste et se sentir sûre avant d'acheter.": "Erhalten Sie eine private Auswahl an Dessous, Kleidern, Nachtwäsche und Größenberatung.",
      "Recevoir mes inspirations privées": "E-Mail für private Inspiration",
      "Recevoir mon accès": "Zugang erhalten",
      "Offre spéciale": "Angebot",
      "Vérifié": "Verifiziert",
      "Guide des tailles": "Größentabelle",
      "Taille": "Größe",
      "Couleur": "Farbe",
      "Prix": "Preis",
      "Description": "Beschreibung",
      "Ajouter au panier": "In den Warenkorb",
      "Acheter maintenant": "Jetzt kaufen",
      "Votre panier": "Warenkorb",
      "Total": "Gesamt",
      "Commander": "Zur Kasse",
      "Continuer mes achats": "Weiter einkaufen",
      "Livraison offerte dans nos pays sélectionnés": "Kostenloser Versand in ausgewählte Länder"
    },
    nl: {
      "NOUVEAUTÉS": "NIEUW BINNEN",
      "LINGERIE": "LINGERIE",
      "NUIT & DÉTENTE": "NACHTMODE & LOUNGE",
      "ROBES & MODE": "JURKEN & MODE",
      "NOS MARQUES": "ONZE MERKEN",
      "SOLDES": "UITVERKOOP",
      "IDÉES CADEAUX": "CADEAU-IDEEËN",
      "Maison européenne de lingerie féminine": "Europese lingerie maison",
      "Lingerie Premium": "Premium lingerie",
      "Soutiens-gorge, ensembles et nuit élégante : confort, maintien et raffinement européen.": "Bh's, sets en elegante nachtkleding met comfort, steun en Europese verfijning.",
      "Découvrir la sélection": "Bekijk de collectie",
      "Voir les nouveautés": "Bekijk nieuw binnen",
      "Livraison offerte": "Gratis verzending",
      "Dans nos pays sélectionnés": "Naar geselecteerde landen",
      "Paiement sécurisé SSL": "Veilig betalen met SSL",
      "Checkout protégé et rapide": "Beschermde, snelle checkout",
      "Suivi colis": "Pakket volgen",
      "Numéro de tracking après expédition": "Trackingnummer na verzending",
      "Choix de taille aidé": "Hulp bij maatkeuze",
      "Tableaux clairs sur les fiches": "Duidelijke maattabellen per product",
      "SÉLECTIONS SIGNATURE": "SIGNATURE SELECTIE",
      "Lingerie femme premium": "Premium lingerie essentials",
      "Les catégories les plus désirées pour trouver vite la coupe, la douceur et l'élégance qui vous correspondent.": "Vind snel de pasvorm, zachtheid en elegantie die bij u past.",
      "SÉLECTION HAUTE DÉSIRABILITÉ": "MEEST GEWILDE SELECTIE",
      "Pièces désirées, coupe raffinée": "Gewilde items, verfijnde pasvorm",
      "Une sélection de modèles en stock, choisis pour leur image, leur coupe et leur potentiel coup de cœur.": "Voorraadmodellen gekozen op uitstraling, pasvorm en favorietgevoel.",
      "SOUS-VÊTEMENTS PAR ENVIE": "LINGERIE OP GEVOEL",
      "Bases lingerie, allure sûre": "Zelfverzekerde lingerie basics",
      "Soutiens-gorge, strings et culottes choisis pour le confort, la confiance et la ligne sous chaque tenue.": "Bh's, strings en slips voor comfort, vertrouwen en een mooie lijn.",
      "ROBES PAR OCCASION": "JURKEN PER MOMENT",
      "Robes pour chaque occasion": "Jurken voor elk moment",
      "Une sélection pensée pour les dîners, cérémonies, cocktails et sorties où la coupe doit donner confiance sans effort.": "Jurken voor diners, ceremonies en momenten waarop de pasvorm vertrouwen geeft.",
      "MARQUES EUROPÉENNES": "EUROPESE MERKEN",
      "Maisons européennes": "Europese maisons",
      "Des marques fabriquées en Europe ou sélectionnées pour leur savoir-faire, leurs coupes et leurs matières raffinées.": "Merken gemaakt in Europa of gekozen om vakmanschap, pasvorm en verfijnde stoffen.",
      "ACHETER EN TOUTE CONFIANCE": "KOPEN MET VERTROUWEN",
      "Chaque détail rassure": "Elk detail stelt gerust",
      "Un parcours pensé pour acheter facilement, choisir la bonne taille et recevoir sa commande avec suivi.": "Eenvoudig kiezen, de juiste maat vinden en uw bestelling volgen.",
      "AVIS CLIENTES": "KLANTREVIEWS",
      "Porté, aimé, vérifié": "Gedragen, geliefd, geverifieerd",
      "Des retours qui comptent vraiment.": "Echte ervaringen die helpen om zeker te kiezen.",
      "CLUB SECRETELLES": "SECRETELLES CLUB",
      "-10% première commande": "-10% eerste bestelling",
      "Votre sélection privée": "Uw privéselectie",
      "Recevez une sélection intime de lingerie femme, robes, nuit élégante et conseils taille, avec des inspirations pensées pour choisir plus juste et se sentir sûre avant d'acheter.": "Ontvang een privéselectie lingerie, jurken, elegante nachtkleding en maatadvies.",
      "Recevoir mes inspirations privées": "E-mail voor privé-inspiratie",
      "Recevoir mon accès": "Toegang ontvangen",
      "Offre spéciale": "Speciale aanbieding",
      "Vérifié": "Geverifieerd",
      "Guide des tailles": "Maattabel",
      "Taille": "Maat",
      "Couleur": "Kleur",
      "Prix": "Prijs",
      "Description": "Beschrijving",
      "Ajouter au panier": "In winkelwagen",
      "Acheter maintenant": "Nu kopen",
      "Votre panier": "Uw winkelwagen",
      "Total": "Totaal",
      "Commander": "Afrekenen",
      "Continuer mes achats": "Verder winkelen",
      "Livraison offerte dans nos pays sélectionnés": "Gratis verzending naar geselecteerde landen"
    }
  };

  function cleanText(text) {
    return String(text || "").replace(/\s+/g, " ").trim();
  }

  function translateTextNodes(root) {
    if (!root || !dictionary[lang]) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        if (!cleanText(node.nodeValue)) return NodeFilter.FILTER_REJECT;
        var parent = node.parentElement;
        if (!parent || /SCRIPT|STYLE|NOSCRIPT|TEXTAREA/.test(parent.tagName)) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(function (node) {
      var original = cleanText(node.nodeValue);
      var translated = dictionary[lang][original];
      if (translated) node.nodeValue = node.nodeValue.replace(original, translated);
    });
  }

  function translateAttributes() {
    if (!dictionary[lang]) return;
    document.querySelectorAll("[placeholder],[aria-label],[title],input[value],button[value]").forEach(function (el) {
      ["placeholder", "aria-label", "title", "value"].forEach(function (attr) {
        if (!el.hasAttribute || !el.hasAttribute(attr)) return;
        var current = cleanText(el.getAttribute(attr));
        if (dictionary[lang][current]) el.setAttribute(attr, dictionary[lang][current]);
      });
    });
  }

  function runTranslations() {
    translateTextNodes(document.body);
    translateAttributes();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", runTranslations);
  } else {
    runTranslations();
  }
  setTimeout(runTranslations, 250);
  setTimeout(runTranslations, 1000);
  setTimeout(runTranslations, 2500);
})();
/* secretelles short blog title runtime */
(function(){
  function run(){
    var lang=(document.documentElement.lang||'fr').slice(0,2).toLowerCase();
    var titles={
      fr:{'lingerie-capsule-wardrobe-essentials-guide':'Garde-robe lingerie capsule','womens-lingerie-style-guide':'Guide lingerie femme','lingerie-gift-guide-how-to-buy-for-someone':'Offrir de la lingerie','lingerie-colors-meaning-psychology-guide':'Couleurs de lingerie'},
      en:{'lingerie-capsule-wardrobe-essentials-guide':'Lingerie capsule wardrobe','womens-lingerie-style-guide':'Women’s lingerie guide','lingerie-gift-guide-how-to-buy-for-someone':'Gifting lingerie','lingerie-colors-meaning-psychology-guide':'Lingerie colours'},
      de:{'lingerie-capsule-wardrobe-essentials-guide':'Lingerie Capsule-Garderobe','womens-lingerie-style-guide':'Damenunterwäsche Guide','lingerie-gift-guide-how-to-buy-for-someone':'Lingerie schenken','lingerie-colors-meaning-psychology-guide':'Lingerie-Farben'},
      es:{'lingerie-capsule-wardrobe-essentials-guide':'Armario cápsula lecería','womens-lingerie-style-guide':'Guía de lecería femenina','lingerie-gift-guide-how-to-buy-for-someone':'Regalar lecería','lingerie-colors-meaning-psychology-guide':'Colores de lecería'},
      nl:{'lingerie-capsule-wardrobe-essentials-guide':'Lingerie capsule garderobe','womens-lingerie-style-guide':'Dameslingerie gids','lingerie-gift-guide-how-to-buy-for-someone':'Lingerie cadeau geven','lingerie-colors-meaning-psychology-guide':'Lingerie kleuren'}
    };
    var map=titles[lang]||titles.fr;
    Object.keys(map).forEach(function(handle){
      document.querySelectorAll('a[href*="/blogs/lingerie-blog/'+handle+'"').forEach(function(link){
        if(link.classList.contains('outline_arrow')) link.setAttribute('aria-label', map[handle]);
        if(link.classList.contains('full-unstyled-link') || link.closest('.article-card')) link.textContent=' '+map[handle]+' ';
      });
    });
    var current=(location.pathname.split('/').pop()||'').trim();
    if(map[current]) document.querySelectorAll('.article-template__title').forEach(function(title){ title.textContent=map[current]; });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',run); else run();
})();
/* secretelles blog final polish */
(function(){
  function polishBlog(){
    var pageLang=(document.documentElement.lang||'fr').slice(0,2).toLowerCase();
    document.querySelectorAll('.se-blog-editorial-hero p').forEach(function(p){
      if(pageLang==='fr' && /Des guides courts/.test(p.textContent)) p.textContent='Guides lingerie femme, taille, matières et style pour choisir avec confiance.';
      p.style.color='#24182f';
    });
    document.querySelectorAll('.main-blog .title--primary').forEach(function(h){h.style.display='none';});
    document.querySelectorAll('.se-blog-editorial-hero h2').forEach(function(h){h.style.fontSize='clamp(3.2rem,4.4vw,5.8rem)';h.style.lineHeight='1';h.style.whiteSpace='nowrap';});
    document.querySelectorAll('.main-blog .article-card__excerpt').forEach(function(p){p.style.color='#24182f';});
    var root=document.querySelector('.article-template__content');
    if(root){
      root.querySelectorAll('img').forEach(function(img){img.style.maxWidth='100%';img.style.height='auto';img.style.objectFit='contain';img.addEventListener('error',function(){img.style.display='none';});});
      root.querySelectorAll('.sl-section-title span:first-child,.sl-tip-title').forEach(function(el){el.textContent=el.textContent.replace(/[✨💎🎨💫🧠👻❤️🤍💙💜🦎✅🎯🛒📰🎁❄️🚫🧺XX]/g,'').trim();});
      root.querySelectorAll('p,li,.sl-stat-text,.sl-faq-a').forEach(function(el){el.style.color='#24182f';});
    }
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',polishBlog); else polishBlog();
})();

/* secretelles blog article luxury runtime cleanup 2026-05-16 */
(function () {
  function ready(fn) {
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", fn);
    else fn();
  }

  function stripEmoji(text) {
    return String(text || "")
      .replace(/[\u{1F300}-\u{1FAFF}\u{2600}-\u{27BF}️]/gu, "")
      .replace(/\s{2,}/g, " ")
      .trim();
  }

  function cleanTextNode(node) {
    var pageLang = (document.documentElement.lang || 'fr').slice(0, 2).toLowerCase();
    node.nodeValue = String(node.nodeValue || "")
      .replace(/[\u{1F300}-\u{1FAFF}\u{2600}-\u{27BF}️]/gu, "");
    if (pageLang === 'fr') {
      node.nodeValue = node.nodeValue
        .replace(/Livraison offerte\s*(d[eè]s|à partir de)\s*129\s*€?/gi, "Livraison offerte dans nos pays sélectionnés")
        .replace(/Livraison offerte\s*(d[eè]s|à partir de)\s*€?\s*129/gi, "Livraison offerte dans nos pays sélectionnés")
        .replace(/Voir le produit\s*→?/gi, "Découvrir la pièce")
        .replace(/Voir la collection\s*→?/gi, "Découvrir la collection");
    }
  }

  ready(function () {
    var root = document.querySelector(".article-template__content");
    var blog = document.querySelector(".main-blog");

    document.querySelectorAll(".se-blog-editorial-hero h1,.se-blog-editorial-hero h2,.main-blog .title--primary,.article-template__title,.article-template__content h1,.article-template__content h2,.article-template__content h3").forEach(function (el) {
      el.style.lineHeight = "1.16";
      el.style.paddingBottom = "0.14em";
      el.style.overflow = "visible";
      el.style.textOverflow = "clip";
    });

    document.querySelectorAll(".article-card .card__inner > .card__content").forEach(function (el) {
      el.style.display = "none";
    });

    if (blog) {
      document.querySelectorAll(".article-card__excerpt,.main-blog .article-card__excerpt").forEach(function (el) {
        el.style.color = "#302438";
      });
    }

    if (!root) return;

    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(cleanTextNode);

    root.querySelectorAll("[class*='icon'],.sl-cap-badge,.sl-categories,.sl-category-links,.sl-trend-pills,.sl-when-wear-list").forEach(function (el) {
      el.style.display = "none";
    });

    root.querySelectorAll(".sl-keyword,mark").forEach(function (el) {
      el.style.background = "transparent";
      el.style.padding = "0";
      el.style.color = "inherit";
    });

    root.querySelectorAll(".sl-product img,.sl-products img,.sl-image img").forEach(function (img) {
      img.style.display = "none";
    });

    root.querySelectorAll("a[class*='sl-btn'],.sl-btn,.se-blog-button").forEach(function (btn) {
      btn.style.color = "#c9a86c";
      btn.style.background = "#55356f";
      btn.style.borderColor = "rgba(201,168,108,.75)";
    });
  });
})();
